import {
  CampaignCreatePageKey,
  CampaignListPageKey,
  CampaignListTableKey,
  CampaignReviewPageKey,
  ReferralAnalyticsKey,
  ReferralBulkActionsKey,
  ReferralReportsKey,
  ReferralRewardModeKey,
  ReferralTierLadderKey
} from '../../TModules';

export const translations = {
  [CampaignListPageKey]: {
    Title: 'Campagne',
    Label: 'Crea Nuova'
  },

  [CampaignListTableKey]: {
    All: 'Tutti',
    Draft: 'Bozza',
    Pending: 'In attesa',
    Scheduled: 'Programmata',
    Active: 'Attiva',
    Ended: 'Terminata',
    Inactive: 'Inattiva',
    SearchPlaceholder: 'Cerca campagna per nome, ID o note interne',
    FilterBy: 'Filtra per',

    // Game Types
    TapWin: 'Tocca e vinci',
    CollectWin: 'Colleziona e vinci',
    ShakeTheTree: "Scuoti l'albero",
    HitThePinata: 'Colpisci la Piñata',
    SpinTheWheel: 'Gira la ruota',
    Plinko: 'Plinko',
    MysteryBox: 'Scatola misteriosa',
    ScratchCard: 'Gratta e vinci',
    BubblePop: 'Bubblicio',
    ClawMachine: 'Macchina ad artiglio',

    OnDeactivateErrorMessage: 'Errore durante la disattivazione della campagna',
    OnApproveErrorMessage: "Errore durante l'approvazione della campagna",
    OnMoveRowErrorMessage: "Errore durante l'ordinamento della campagna.",

    Approve: 'Approva',
    Review: 'Revisiona',
    Edit: 'Modifica',
    Activate: 'Attiva',
    Deactivate: 'Disattiva',
    Duplicate: 'Duplica',
    UploadTries: 'Carica tentativi',
    MoveToTop: 'Sposta in cima',
    ApproveCampaign: 'Approva campagna',

    Name: 'Nome',
    Type: 'Tipo',
    Status: 'Stato',
    StartDate: 'Data inizio',
    EndDate: 'Data fine',
    Request: 'Richiesta',
    Comments: 'Commenti',
    Actions: 'Azioni',
    AllGames: 'Tutti i giochi',
    ApproveRequests: 'Approva richieste',
    CampaignTypeNotAllowedForApproval:
      'Questo tipo di campagna non è abilitato. Contattare Perx per ulteriore assistenza.',
    InternalNotes: 'Note interne',
    ApproveMultipleMessageModal: {
      MultipleApproveRequestSuccessMessage: 'Le richieste sono state approvate',
      SuccessMessage: 'Campagne approvate',
      ErrorMessage: "Errore durante l'approvazione delle campagne.",
      Title: 'Approvare più richieste?',
      OkText: 'Approva selezionati',
      CancelText: 'Annulla',
      DescriptionLineOne: 'Sei sicuro di voler approvare tutte le richieste selezionate?',
      DescriptionLineTwo:
        'Verifica i dettagli prima di approvare poiché questa azione non può essere annullata.',
      ErrorApprovingRewards: "Errore durante l'approvazione dei premi."
    },

    ApproveMessageModal: {
      SuccessMessage: 'La richiesta è stata approvata',
      FailureMessage: "Errore durante l'approvazione della campagna.",
      Title: 'Approvare la campagna?',
      OkText: 'Approva',
      DescriptionLineOne: 'Sei sicuro di voler approvare questa campagna?',
      DescriptionLineTwo: 'Questa azione non può essere annullata.'
    },

    CampaignType: {
      AllCampaigns: 'Tutte le campagne',
      InstantReward: 'Premio immediato',
      Stamp: 'Timbro',
      Referral: 'Riferimento',
      Game: 'Gioco',
      Reward: 'Premio',
      Quiz: 'Quiz',
      Survey: 'Sondaggio',
      Quest: 'Quiz',
      Progress: 'Progressione',
      Raffle: 'Raffle',
      MultipleRuleCampaign: 'Campagna a regole multiple'
    }
  },

  [CampaignCreatePageKey]: {
    CreatingACampaign: 'Creazione di una campagna',
    CampaignCreated: 'Campagna creata',
    CampaignSubmittedForApproval: "La campagna è stata inviata per l'approvazione",
    FailedToCreateCampaign: 'Creazione della campagna non riuscita',
    DeactivatingCampaign: 'Disattivazione della campagna...',
    CampaignDeactivationRequestSubmittedForApproval:
      "Richiesta di disattivazione della campagna inviata per l'approvazione!",
    DeactivatingSuccess: 'Disattivazione avvenuta con successo...',
    FailedToDeactivate: 'Disattivazione non riuscita!',

    ActivatingCampaign: 'Attivazione della campagna...',
    CampaignActivationRequestSubmittedForApproval:
      "Richiesta di attivazione della campagna inviata per l'approvazione!",
    ActivatingSuccess: 'Attivazione avvenuta con successo...',
    FailedToActivate: 'Attivazione non riuscita!',
    UpdatingCampaign: 'Aggiornamento della campagna',
    CampaignUpdateRequestSubmittedForApproval: "La campagna è stata inviata per l'approvazione!",
    FailedToUpdate: "Errore durante l'aggiornamento della campagna!",

    FailedToLoadData: 'Caricamento dei dati non riuscito!',
    FailedToOrderCampaign: 'Ordinamento della campagna non riuscito!',

    DuplicatingCampaign: 'Duplicazione campagna...',
    OnSubmitErrorMessage: 'Nessuna modifica rilevata',

    RequiredErrorMessage: 'Il nome della campagna è obbligatorio',
    UploadedImagesShouldBeSetAsASection:
      'Le immagini caricate devono essere impostate come una sezione',
    PromoteUntilMustBeAfterStartDate:
      'La data di promozione deve essere successiva alla data di inizio',
    PromoteUntilMustBeBeforeEndDate:
      'La data di promozione deve essere precedente alla data di fine',
    PromoteUntilMustBeBetweenStartAndEndDate:
      'La data di promozione deve essere compresa tra la data di inizio e la data di fine',
    PleaseSelectAnOwner: 'Seleziona un proprietario',
    PleaseAddAtLeast2Outcomes: 'Aggiungi almeno 2 risultati',
    EndDateCannotBeEarlierThanStartDate:
      'La data di fine deve essere uguale o successiva alla data di inizio',
    PrizeSetMustIncludeAtLeastOnePrizeForSlotNumber:
      'Il set di premi deve includere almeno un premio per la posizione numero {{position}}',
    PleaseAddAPrizeTitleForSlotNumber:
      'Aggiungi un titolo del premio per la posizione numero {{position}}',
    PleaseAddAtLeast2OutcomesForSlotNumber:
      'Aggiungi almeno 2 risultati per la posizione numero {{position}}',
    PrizeSetMustIncludeAtLeastOnePrize: 'Il set di premi deve includere almeno un premio',
    RandomOutcomeSetMustIncludeAtLeastOneOutcome:
      'Il set di risultati casuali {{index}} deve includere almeno un risultato',
    RandomOutcomeSetMustIncludeAtLeastTwoOutcomes:
      'Il set di risultati casuali {{index}} deve includere almeno 2 risultati',
    TotalProbabilityOfRandomOutcomeSet:
      'La probabilità totale del set di risultati casuali {{index}} deve essere 100%',
    HeadlineHasToBeSet: 'Il titolo deve essere impostato',
    SubHeadlineHasToBeSet: 'Il sottotitolo deve essere impostato',
    RewardMustBePlacedOnAtLeastOneWedge: 'Il premio deve essere posizionato su almeno una sezione',
    AtLeast1WedgeMustRemainEmptyIfNoOutcomeIsSelected:
      'Almeno una sezione deve rimanere vuota se viene selezionato "Nessun risultato"',
    EachOutcomeMustHaveADuplicateScore:
      'Ogni risultato deve avere un punteggio unico. Duplicati trovati: {{duplicateList}}',
    ScoreMustBeGraterThanZero: 'Il punteggio deve essere maggiore di 0.',
    AtLeastOneBubbleMustBeConfigured: 'Deve essere configurata almeno una bolla',
    ColorHasToBeSet: 'Il colore deve essere impostato',
    PointHasToBeSet: 'Il punto deve essere impostato',
    SVGCodeIsRequired:
      "Il codice SVG è obbligatorio quando viene selezionata un'immagine personalizzata.",
    TargetTypeMustBeSelected: 'Il tipo di obiettivo deve essere selezionato.',
    BubbleSpawnRateMustBeSelected: 'La frequenza di comparsa delle bolle deve essere selezionata.',
    MaxBubblesMustBePositive: 'Il numero max. di bolle deve essere un numero positivo.',
    SpawnIntervalMustBeAtLeast100ms:
      "L'intervallo di comparsa deve essere di almeno 100 millisecondi.",
    BubbleLifetimeMustBeAtLeast500ms:
      'La durata della bolla deve essere di almeno 500 millisecondi.',
    BubblesPerSpawnMustBePositive: 'Le bolle per comparsa devono essere un numero positivo.',
    BubblesPerSpawnMustNotExceedMaxBubbles:
      'Le bolle per comparsa non devono superare il numero max. di bolle.',
    GameDurationMinimum10Seconds: 'La durata del gioco deve essere di almeno 10 secondi.',
    MaximumOf5BubblesCanBeMarkedAsBonus:
      'Un massimo di 5 bolle possono essere contrassegnate come bonus.',
    BonusImageOccurrenceMustBeBetween1And6:
      "L'occorrenza dell'immagine bonus deve essere tra 1 e 6.",
    PrizeModeHasToBeSelected: 'La modalità premio deve essere selezionata.',
    ArmAccuracyMustBeAWholeNumberBetween0And100:
      'La precisione del braccio deve essere un numero intero tra 0 e 100.',
    FixedPrizeModeNeedsAtLeastOnePrize: 'La modalità premio fisso richiede almeno 1 premio.',
    RandomPrizeModeNeedsAtLeastTwoPrizes: 'La modalità premio casuale richiede almeno 2 premi.',
    NoPrizeIsOnlyAvailableInRandomPrizeMode:
      '"Includi nessun premio come risultato" è disponibile solo nella modalità premio casuale.',
    EveryPrizeNeedsASlotInFixedPrizeMode:
      'Ogni premio richiede una posizione nella modalità premio fisso.',
    PrizeSlotsMustNotRepeat: 'Le posizioni dei premi non devono ripetersi.',
    EveryPrizeNeedsAnIconInFixedPrizeMode:
      "Ogni premio richiede un'icona nella modalità premio fisso.",
    PrizeIconsMustNotRepeatTheSameImage: "Ogni icona premio deve utilizzare un'immagine diversa.",
    EveryPrizeIconMustMatchItsPrizeSlot:
      'Ogni icona premio deve corrispondere alla sua posizione premio.',
    EveryPrizeNeedsAProbabilityInRandomPrizeMode:
      'Ogni premio richiede una probabilità nella modalità premio casuale.',
    ProbabilityCannotBeNegative: 'La probabilità non può essere negativa.',
    ProbabilityTakesAtMost6DecimalPlaces: 'La probabilità accetta al massimo 6 decimali.',
    ClawMachineDoesNotSupportThisOutcomeType:
      'I premi della macchina ad artiglio possono essere solo premi, punti, badge, set di premi o nessun premio.',
    YouNeedToAddAtLeastOneQuestionToThe: 'Devi aggiungere almeno una domanda al {{campaignType}}.',
    EnglishTextForTheQuestionIsRequired:
      'Il testo inglese per la domanda #{{questionNumber}} è obbligatorio',
    EnglishTextForTheChoiceIsRequired:
      'Il testo inglese per la scelta #{{choiceNumber}} della domanda #{{questionNumber}} è obbligatorio',
    YouNeedToAddAtLeastOneTask: 'Devi aggiungere almeno un compito',
    YouNeedToSpecifyARuleForTheTask: 'Devi specificare una regola per il compito #{{taskNumber}}',
    CampaignDurationIsRequired: 'La durata della campagna è obbligatoria',
    CampaignDurationMustBeGreaterThanZero: 'La durata della campagna deve essere superiore a 0',
    BodyHasToBeSetForQuestDisplaySetup:
      'Il corpo deve essere impostato per la configurazione della visualizzazione della missione',
    YouNeedToSpecifyTheTeamSize: 'Devi specificare la dimensione del team',
    TeamSizeMustBePositive: 'La dimensione del team deve essere positiva',
    EnglishHeadlineCannotBeEmpty: 'Il titolo in inglese non può essere vuoto',
    LevelTabNameCannotBeEmpty: 'Il nome della scheda "Livello" non può essere vuoto',
    CampaignPointsShortFormCannotBeEmpty:
      'La forma abbreviata dei punti campagna non può essere vuota',
    YouNeedToSpecifyACampaignPointsForTheLevel:
      'Devi specificare i punti campagna per il livello #{{levelNumber}}',
    YouNeedToSpecifyAnIssuePrizeDescriptionForTheLevel:
      'Devi specificare una descrizione del "Premio emesso" per il livello #{{levelNumber}}',
    LevelPointsMustBeMoreThanLevelPoints:
      'I punti del livello {{levelNumber}} devono essere maggiori dei punti del livello {{errorIndex}}!',
    YouNeedToAddAtLeast2OutcomesForTheLevel:
      'Devi aggiungere almeno 2 risultati per il livello #{{levelNumber}}',
    PrizeSetRequiresAPrizeTitleForTheLevel:
      'Il set di premi richiede un titolo del premio per il livello #{{levelNumber}}',
    YouNeedToAddAtLeastOneOutcomeForTheRandomizedOutcomeSet:
      'Devi aggiungere almeno un risultato per il set di risultati casuali {{randomOutcomeIndex}} nel livello #{{levelNumber}}',
    TheProbabilitiesOfTheOutcomesInRandomizedOutcomeSet:
      'Le probabilità dei risultati nel set di risultati casuali {{randomOutcomeIndex}} del livello #{{levelNumber}} devono sommare a 100%',
    EachOutcomeProbabilityInRandomizedOutcomeSetMustBeGreaterThanZero:
      'La probabilità di ciascun risultato nel set di risultati casuali {{randomOutcomeIndex}} del livello #{{levelNumber}} deve essere superiore a 0%',
    HowToParticipateTabNameCannotBeEmpty:
      'Il nome della scheda "Come partecipare" non può essere vuoto',
    HowToParticipateBodyTextCannotBeEmpty:
      'Il testo della scheda "Come partecipare" non può essere vuoto',
    NumbersHaveToBeLessThan: 'I numeri devono essere inferiori a {{maxValue}}!',
    OperatingClosesTimeShouldBeGreaterThanOperatingOpensTime:
      "L'orario di chiusura deve essere successivo all'orario di apertura",
    OperatingOpensTimeShouldBeEarlierThanOperatingClosesTime:
      "L'orario di apertura deve essere precedente all'orario di chiusura",
    DaysCannotBeEmptyPleaseSelectValidDays:
      'I giorni non possono essere vuoti. Seleziona giorni validi',
    TimesCannotBeEmptyPleaseSelectValidTimes:
      'Gli orari non possono essere vuoti. Seleziona orari validi',
    ProbabilityMustAlwaysAddUpTo100: 'La probabilità deve sempre essere pari al 100%',
    ProbabilityShouldBeGreaterThan0: 'La probabilità deve essere superiore a 0%',
    OutcomesCannotBeEmpty: 'I risultati non possono essere vuoti.',
    PleaseAddOutcomesToWedges: 'Aggiungi risultati agli spicchi: {{wedges}}',
    EndDateCannotBeEmpty: 'La data di fine non può essere vuota.',
    AddAtLeastOneRule: 'Aggiungi almeno una regola',
    AddAtLeastOnePrizeSet: 'Aggiungi almeno un set di premi',
    AddAtLeastOneOutcomeToThePrizeSet: 'Aggiungi almeno un risultato al set di premi',
    PleaseUploadTheFile: 'Carica il file',
    CampaignRequestUpdated: 'Richiesta di campagna aggiornata',
    CampaignIsSubmittedForApproval: "Campagna inviata per l'approvazione",
    CampaignUpdated: 'Campagna aggiornata',
    IncompleteAudienceFilters:
      'Completa o rimuovi questi filtri di pubblico prima di procedere: {{filters}}.',
    LimitTo: 'Limitare a',
    SelectTaskTypeIsRequired: 'Il tipo di attività è obbligatorio',
    StreakModeIsRequired: 'La modalità serie è obbligatoria',
    AmountSpendIsRequired: 'L’importo speso è obbligatorio',
    AmountSpendMustBeGreaterThanZero: 'L’importo speso deve essere maggiore di zero',
    StreakTargetIsRequired: 'L’obiettivo della serie è obbligatorio',
    StreakTargetMustBeGreaterThanZero: 'L’obiettivo della serie deve essere maggiore di zero',
    StreakTargetCriteriaIsRequired: 'I criteri dell’obiettivo della serie sono obbligatori',
    StreakTargetCriteriaMustBeGreaterThanZero:
      'I criteri dell’obiettivo della serie devono essere maggiori di zero',
    StreakDurationIsRequired: 'La durata della serie è obbligatoria',
    MilestonesAndPrizesAreRequired: 'Traguardi e premi sono obbligatori',
    AtLeastOneOutcomeIsRequiredForMilestonesAndPrizes:
      'È richiesto almeno un risultato per traguardi e premi',
    AtLeastOneConditionIsRequired: 'È richiesta almeno una condizione',
    InvalidCondition: 'Condizione non valida',
    SelectTriggerFieldIsRequired: 'Il campo trigger è obbligatorio',
    OperatorFieldIsRequired: 'Il campo operatore è obbligatorio',
    ValueIsRequired: 'Il valore è obbligatorio',

    Steps: {
      Back: 'Indietro',
      Cancel: 'Annulla',
      Next: 'Avanti',
      SaveAsDraft: 'Salva come bozza',
      Publish: 'Pubblica',
      Save: 'Salva',
      Deactivate: 'Disattiva',
      Schedule: 'Programma',
      StreakMode: 'Modalità serie',
      TaskType: 'Tipo di attività',
      StreakTargetAndPrizes: 'Obiettivo serie e premi',

      Info: 'Info',
      SelectAudience: 'Seleziona Pubblico',
      Mechanics: 'Meccaniche',
      Review: 'Revisione',
      DetailedTitle: {
        Info: 'Info Campagna',
        SelectAudience: 'Seleziona Pubblico',
        Mechanics: 'Meccaniche',
        Review: 'Revisione'
      },
      ViewInsights: 'Visualizza insights',
      Edit: 'Modifica',
      Loading: 'Caricamento'
    },

    CampaignInfo: {
      Title: 'Dettagli campagna',
      Form: {
        Name: 'Nome',
        NamePlaceholder: 'Inserisci il nome della tua campagna',
        ContentSuggestions: 'Suggerimenti contenuto',
        ShowChatGPTForm: {
          TooltipTitle:
            'I limiti dei token si rinnovano giornalmente. Diventa un membro esclusivo Perx per token illimitati',
          TokensLeft: 'token rimasti'
        },
        Description: 'Descrizione',
        TermsAndConditions: 'Termini e condizioni',
        RiskDisclaimer: 'Disclaimer sui rischi',
        InternalNotesNotVisibleToCustomers: 'Note interne (non visibili ai clienti)',
        InternalNotesNotVisibleToCustomersPlaceholder:
          'Inserisci note facoltative solo per uso interno. Questo testo non è visibile ai clienti.',
        MaxCharacters: 'Max {{count}} caratteri.',
        CampaignDuration: 'Durata campagna',
        StartDate: 'Data inizio',
        EndDate: 'Data fine',
        EarlyDisplayCampaign: 'Inizia a mostrare la campagna',
        DaysBeforeStartDate: 'giorni prima della data di inizio',
        DaysBeforeTheStartDate: 'giorni prima della data di inizio',
        CampaignDoesNotEnd: 'La campagna non termina',
        ShouldHideDurationEndDateAlertMessage:
          'Le campagne a estrazione richiedono una data di fine',
        EndDateAlertMessage: 'La data di fine deve essere uguale o successiva alla data di inizio',

        Reset: 'Reimposta',
        OCBCDemo: {
          Never: 'Mai',
          Weekly: 'Settimanale',
          Monthly: 'Mensile',
          Yearly: 'Annuale'
        },

        ActiveAt: 'Attiva il',
        ActiveAtMessage: 'La campagna non si attiva prima della data di inizio',

        Tags: 'Tag',
        Categories: 'Categorie',
        Labels: 'Etichette',
        Catalogues: 'Cataloghi',
        Owner: 'Proprietario',
        PleaseSelectAnOwner: 'Seleziona un proprietario',

        UploadPhoto: 'Carica foto',
        UploadMultipleImages: 'Carica più immagini',
        Merchant: 'Commerciante',
        MerchantSelectPlaceholder: 'Seleziona un commerciante',
        Locations: 'Località',
        LocationsSelectPlaceholder: 'Seleziona località',
        CustomFields: 'Campi personalizzati',
        CustomField: 'Campo personalizzato',
        CustomFieldNamePlaceholder: 'Inserisci il nome del campo',
        CustomFieldValuePlaceholder: 'Inserisci il valore del campo',
        AddCustomField: 'Aggiungi campo personalizzato'
      },

      TagSelect: 'Seleziona i tuoi tag',
      CategorySelect: 'Seleziona le tue categorie',
      LabelSelect: 'Seleziona le tue etichette',
      CatalogueSelect: 'Seleziona i tuoi cataloghi'
    },

    ButtonWithImageUpload: {
      Cancel: 'Annulla',
      InsertPhoto: 'Inserisci foto',
      UploadFile: 'Carica un file',
      ChooseFile: 'Scegli file',
      ChooseAFile: 'Scegli un file',
      SelectPngSvgJpegGif: 'Seleziona PNG, SVG, JPEG o GIF'
    },

    CampaignSelectAudience: {
      SelectAudience: 'Seleziona un pubblico',
      DefaultAudience: 'Crea un pubblico a uso singolo per questa campagna',
      ExistingAudience: 'Seleziona un pubblico esistente',
      AudienceSetup: 'Impostazioni pubblico',
      SelectFilters: 'Seleziona filtri',
      SelectedFilters: 'Filtri selezionati',

      AudienceListSetup: {
        Include: 'Includi',
        Exclude: 'Escludi',
        AudienceExistsMessage: `Non puoi {{audienceIncludeExclude}} pubblico che è già impostato per {{audienceIncludeExcludeNoun}}`,
        PickAudienceList: 'Scegli una lista di pubblico',

        Includes: 'Inclusi',
        Excludes: 'Esclusi',
        AudienceWarningMessage:
          'Il file del pubblico caricato verrà elaborato solo dopo che sarà stato approvato da un approvatore di azioni in blocco',
        SelectedFileForInclusion: 'File selezionato per inclusione',
        AudienceNotInTheList: 'Pubblico non nella lista',
        IncludeAudienceFilenamePlaceholder: 'Nome la lista di inclusione pubblico',
        UploadNow: 'Carica ora',
        UploadNewList: 'Carica nuova lista',
        AcceptedFormat: 'Formato accettato: file .xlsx/.csv solo.',
        DownloadSample: 'Scarica esempio',
        UploadExclusion: 'Carica esclusione',
        SelectedFileForExclusion: 'File selezionato per esclusione',
        ExcludeAudienceFilenamePlaceholder: 'Nome la lista di esclusione pubblico'
      },
      AudienceFilters: {
        Age: 'Età',
        BirthMonth: 'Mese di nascita',
        Gender: 'Sesso',
        Location: 'Località',
        Loyalty: 'Fedeltà',
        Personal: 'Personale',
        Custom: 'Personalizzato',
        EmailTags: 'Tags email',
        Ethnicity: 'Etnia',
        SelectCustomerAttributeFilters: 'Seleziona i tuoi filtri di attributo cliente',
        NoFiltersSelected: 'Nessun filtro selezionato',
        And: 'e',
        Badge: 'Badge',
        Campaign: 'Campagna',
        Leaderboard: 'Classifica',
        LoyaltyPoints: 'Punti fedeltà',
        LoyaltyTier: 'Livello fedeltà',
        MemberSince: 'Membro dal',
        Reward: 'Premio',
        PaymentBased: 'Basato sul pagamento',
        Payment: 'Pagamento',
        SelectFilters: 'Seleziona i filtri per generare automaticamente una lista di pubblico',
        City: 'Città',
        States: 'Regioni',

        OfferId: 'ID Offerta',
        PrimaryClusterComb: 'Combinazione Cluster Primario',
        PrimaryClusterState: 'Stato Cluster Primario',
        Membership: 'Membro Di',
        CurrentBirthday: 'Solo Durante il Giorno di Nascita',
        CurrentBirthMonth: 'Solo Durante il Mese di Nascita',
        HasBirthday: 'Nel Compleanno',
        UserType: 'Tipo Utente',
        AccountConfirmedAt: 'Registrato tra',
        LoyaltyPointsBalance: 'Saldo punti',
        CampaignEnrolment: 'Campagna',
        LeaderboardPosition: 'Posizione in classifica',
        UPI: 'UPI',
        ScanPay: 'Scan pay',
        BBPS: 'BBPS',
        KYC: 'KYC',
        CurrentAddress: 'Indirizzo attuale',
        PaymentStatus: 'Stato pagamento',
        DaysPastDues: 'Giorni di ritardo',
        BNPLUnpaidEMIDate: 'Data EMI non pagata BNPL',
        InstaloanUnpaidEMIDate: 'Data EMI non pagata Instaloan',

        AgeFilter: {
          Title: 'Età',
          Includes: 'Inclusi',
          Excludes: 'Esclusi',
          SelectPlaceholder: 'Inclusi',
          From: 'da',
          FromPlaceholder: '18',
          To: 'a',
          ToPlaceholder: '35',
          AddRange: 'Aggiungi intervallo',
          And: 'e',
          from: 'da'
        },

        BirthdayFilter: {
          Title: 'Compleanno',
          SelectBirthMonth: 'Seleziona mese di nascita',
          BirthMonth: 'Mese di nascita',
          CurrentBirthMonth: 'Mese di nascita corrente',
          OnlyDuringMonthOfBirth: 'Solo durante il mese di nascita',
          HasBirthday: 'Ha il compleanno',
          OnBirthday: 'Nel giorno del compleanno',
          Includes: 'Inclusi',
          Excludes: 'Esclusi'
        },
        GenderFilter: {
          Title: 'Genere',
          SelectByGender: 'Seleziona per genere',
          Male: 'Maschio',
          Female: 'Femmina'
        },
        EthnicityFilter: {
          Title: 'Etnia',
          SelectEthnicity: 'Seleziona etnia',
          SelectEthnicityPlaceholder: 'Seleziona etnia',
          Include: 'Includi',
          Exclude: 'Escludi',
          Includes: 'Inclusi',
          Excludes: 'Esclusi'
        },
        LocationFilter: {
          Title: 'Località',
          SelectCity: 'Seleziona città',
          Include: 'Includi',
          Exclude: 'Escludi',
          SelectCityPlaceholder: 'Seleziona città',
          SelectState: 'Seleziona regione',
          SelectStatePlaceholder: 'Seleziona regione',
          Includes: 'Inclusi',
          Excludes: 'Esclusi'
        },

        PersonalFilter: {
          Title: 'Personale',
          HubClub: 'Hub Club',
          Select: 'Seleziona',
          Include: 'Includi',
          Exclude: 'Escludi',
          AddCustomProperties: 'Aggiungi proprietà personalizzate',
          EnterKeyNameAndValueDetails: 'Inserisci nome chiave e dettagli valore',
          SelectRelation: 'Seleziona relazione',
          EnterNumber: 'Inserisci numero',
          KeyValue: 'Valore chiave',
          DatePlaceholder: 'GG-MM-AAAA',
          KeyNamePlaceholder: 'Nome chiave',
          Is: 'È',
          True: 'Vero',
          False: 'Falso',
          And: 'E',
          Or: 'O',
          CustomAttributeType: 'Attributo personalizzato #{{index}}: tipo',
          CustomAttribute: 'Attributo personalizzato #{{index}}: attributo',
          CustomAttributeOperator: 'Attributo personalizzato #{{index}}: operatore',
          CustomAttributeValue: 'Attributo personalizzato #{{index}}: valore'
        },

        LoyaltyFilter: {
          Title: 'Fedeltà',
          SelectLoyaltyProgram: 'Seleziona programma fedeltà',
          Include: 'Includi',
          Exclude: 'Escludi',
          SelectProgram: 'Seleziona programma',
          Includes: 'Inclusi',
          Excludes: 'Esclusi',
          UsersWithPointsBalance: 'Utenti con saldo punti',
          SelectLoyaltyProgramPlaceholder: 'Seleziona programma fedeltà',
          From: 'Da',
          To: 'A',
          PointsBalanceFrom: 'Saldo punti da',
          PointsBalanceTo: 'Saldo punti a'
        },

        EmailTagsFilter: {
          Includes: 'Include',
          SelectEmailTags: 'Seleziona tag email',
          Excludes: 'Esclude'
        }
      }
    },

    SocialMediaFields: {
      Title: 'Social media',
      OGTitle: 'Titolo',
      OGDescription: 'Descrizione',
      OGImage: 'Immagine',
      OGImageAlt: 'Anteprima social media',
      IOSAppLink: 'Link app iOS',
      AndroidAppLink: 'Link app Android',
      WebLink: 'Link Web',
      EitherAnIOSOrAndroidOrWebLinkIsRequired: 'Un link iOS, Android o Web è richiesto',
      Allowed: 'Permesso: .jpg, .png, .svg',
      Browse: 'Sfoglia',
      Recommended: 'Consigliato: 720px by 120px',
      TitleIsRequired: 'Il titolo è obbligatorio.'
    },

    CampaignMechanics: {
      CampaignType: 'Tipo di campagna',
      InstantReward: 'Premio istantaneo',
      MultipleRuleCampaign: 'Campagna a regole multiple',
      Reward: 'Premio',
      Progress: 'Progresso',
      Raffle: 'Lotteria',
      Stamp: 'Timbro',
      Game: 'Gioco',
      Quest: 'Missione',
      Referral: 'Riferimento',
      Survey: 'Sondaggio',
      Quiz: 'Quiz',
      Streak: 'Serie',
      GiveRewardTitle: 'Rilascio immediato di tutti i premi',
      Yes: 'Sì',
      No: 'No',

      OutcomeType: 'Tipo di risultato',
      FixedPrize: 'I clienti ricevono un premio fisso',
      ChoosePrize: 'I clienti scelgono il premio preferito',

      PrizeMode: 'Modalità di gioco',
      FixedPrizeMode: 'I clienti afferrano un premio fisso',
      RandomPrizeMode: 'Il cliente riceve un premio casuale (blindbox)',
      PrizeModeSwitchTitle: 'Cambiare la modalità premio?',
      PrizeModeSwitchWarning:
        'Premio fisso e Premio casuale danno un significato diverso a un premio: il cambio ricrea tutti i premi di questa campagna. Le probabilità di vincita vengono azzerate e ogni premio riceve un nuovo riferimento.',

      GameTry: 'Tentativo di gioco',
      AwardBadges: 'Assegna badge',
      AwardPoints: 'Assegna punti',
      AddRewards: 'Aggiungi premi',
      AddPrizeToSet: 'Aggiungi premio al set',
      IncludeNoPrizeAsOutcome: 'Includi nessun premio come risultato',
      RandomOutcomeSet: 'Set di risultati casuali {{index}}',
      PrizeSet: 'Set premio {{index}}',

      LevelsAndPrizes: 'Livelli e premi',
      LandingPage: 'Pagina di atterraggio',
      ProgressMechanics: 'Meccaniche di progresso',

      InstantRewardMechanics: 'Meccaniche di premio istantaneo',
      ListCheckboxLabel: "Mostrare la campagna nell'elenco campagne dell'utente?",
      ListCheckboxSendPushNotificationLabel:
        'Inviare una notifica push per ogni attivazione di regola?',
      MediaTagsToInclude: 'Tag media da includere',
      SelectMediaTags: 'Seleziona tag media',
      AddRule: 'Aggiungi regola',
      Name: 'Nome',
      Action: 'Azione',
      Edit: 'Modifica',
      Remove: 'Rimuovi',

      IssuanceLimits: 'Limiti di emissione',
      TotalNumberOfIssuePrizeEventsOnCampaignLevel:
        'Numero totale di eventi di emissione premio (a livello di campagna)',
      TotalNumberOfIssuePrizeEventsPerUser:
        'Numero totale di eventi di emissione premio (per utente)',
      IssuanceLimitsPerUser: 'Limiti di emissione (per utente)',
      IssuanceLimitsPerUserPlaceholder: '∞',
      IssuePrizeEvents: 'evento/i di emissione premio',
      RateLimitOnCampaignLevel: 'Limite di frequenza (a livello di campagna)',
      IssuePrizeEventsForEvery: 'evento/i di emissione premio ogni',
      Day: 'giorno',
      RateLimitPerUser: 'Limite di frequenza (per utente)',
      LimitTo: 'Limita a',
      LeaveTheLimitFieldsBlankForUnlimitedIssuePrizeEvents:
        '^ Lascia il campo vuoto per eventi di emissione premio illimitati',
      SvgHarmfulTagsRemovedSuccessfully: 'Tag dannosi SVG rimossi con successo!',
      ImageHelpText: 'Rapporto 1:1 consigliato, massimo 500kb in jpg o png',
      Upload: 'Carica',

      PrizeEarnedPopUp: 'Popup premio guadagnato',
      AppearsUponCustomerSignInToMicrosite: 'Appare al login del cliente nel microsito',
      Headline: 'Titolo',
      PleaseInputYourHeadline: 'Inserisci il tuo titolo',
      SubHeadline: 'Sottotitolo',
      PleaseInputYourSubHeadline: 'Inserisci il tuo sottotitolo',
      Image: 'Immagine',
      ClaimPrizeButtonText: 'Testo bottone riscatta premio',
      PleaseInputClaimPrizeButtonText: 'Inserisci il testo del bottone riscatta premio',
      AddTask: 'Aggiungi attività',
      SomethingWentWrong: 'Qualcosa è andato storto',
      MaxNumberReachedWarning: 'Limite di 10 attività per missione raggiunto',
      TaskIndex: 'Attività {{index}}',
      WinProbability: 'Probabilità di guadagno:',
      WinProbabilityPercent: 'Probabilità di guadagno %',
      loyaltypoints: 'punti fedeltà',
      loyaltypoint: 'punto fedeltà',

      StampRuleTable: {
        ID: 'ID',
        Name: 'Nome',
        RuleType: 'Tipo di regola',
        NumberOfStamps: 'Numero di timbri',
        RaffleTicketsColumn: 'Biglietti della lotteria',
        RaffleTicketsVariableValue: '{{x}} ogni {{y}} (max {{z}})',
        Action: 'Azione',
        Edit: 'Modifica',
        Remove: 'Rimuovi'
      },

      SelectOutcomes: 'Seleziona risultati',
      OnlyRewardsWithConfiguredTags:
        'Solo i premi con tag configurati possono essere selezionati quando i clienti scelgono il loro premio.',
      ConfigureRaffleCodes: {
        Title: 'Configura codici lotteria',
        SelectCodeType: 'Seleziona tipo di codice',
        SystemGenerated: 'Generato dal sistema',
        UserUpload: 'Caricamento utente',
        TicketCodePrefix: 'Prefisso codice biglietto',
        LengthOfCode: 'Lunghezza del codice',
        NumberOfTickets: 'Numero di biglietti',
        CodeFormat: 'Formato codice',
        TotalPermutations: 'Permutazioni totali',
        SelectFile: 'Seleziona file',
        UploadCodes: 'Carica codici',
        AcceptedFormats: 'Formati accettati: solo file .txt, .xlsx o .csv.'
      },

      RaffleRules: {
        Title: 'Regole di guadagno',
        AddRule: 'Aggiungi regola'
      },

      GrandPrizes: {
        Title: 'Premi principali',
        LimitGrandPrizesToOnePerCustomerOnly: 'Limita i premi principali a uno solo per cliente',
        ThisSettingRequiresMultipleGrandPrizesToBeDefined:
          'Questa impostazione richiede che siano definiti piu premi principali',
        AllocateRafflePrizesForIndividualPositionsOrARange:
          'Assegna premi lotteria per posizioni individuali o un intervallo. Es: set premio 1 per il 1° classificato e set premio 2 per i classificati dal 2° al 5°.',
        AddPrizeSet: 'Aggiungi set premio',
        Position: 'Posizione:',
        PrizeSetWithPositionStartsWith: 'Set premio {{index}}: posizione inizia da',
        PrizeSetWithPosition: 'Set premio {{index}}: posizione',
        PrizeSet: 'Set premio {{index}}',
        ConvertPositionToRange: 'Converti posizione in intervallo'
      },

      OutcomeSettings: {
        Title: 'Impostazioni risultato - appare al login del cliente nel microsito',
        RaffleTicketOutcome: 'Risultato biglietto lotteria',
        GrandPrizeOutcome: 'Risultato premio principale',
        RaffleTicket: 'Biglietto lotteria',
        GrandPrize: 'Premio principale',
        Headline: 'Titolo',
        Subheadline: 'Sottotitolo',
        WinRewardGraphic: 'Grafica premio vinto',
        ClaimTicketButtonText: 'Testo bottone riscatta biglietto',
        ClaimPrizeButtonText: 'Testo bottone riscatta premio'
      },

      QuestMechanics: {
        Title: 'Meccaniche missione',
        SequentialTasks: 'Le attività della missione devono essere completate in sequenza',
        Yes: 'Sì',
        No: 'No',
        UserTriesValidity: 'Validità tentativi utente',
        UserTriesValidityPlaceholder: '100',
        UserTriesValidityPeriodPlaceholder: 'giorni',
        Hours: 'ore',
        Days: 'giorni',
        Months: 'mesi',
        Years: 'anni',
        TotalNumberofQuests: 'Numero totale di missioni avviabili in una campagna',
        TotalNumberofQuestsPlaceholder: '∞',
        Quests: 'missioni',
        TotalNumberofQuestsPerUser: 'Numero totale di missioni avviabili da ciascun utente',
        TotalNumberofQuestsPerUserPlaceholder: '∞',
        LeaveTheLimitFieldsBlankForUnlimitedIssuances:
          '^ Lascia il campo vuoto per emissioni illimitate',
        QuestDisplaySetUp: 'Impostazione visualizzazione missione',
        Headline: 'Titolo',
        SubHeadline: 'Sottotitolo',
        BodyText: 'Testo principale',
        Image: 'Immagine',
        ImageHelpText: 'Dimensione minima 360(l) x 144(a) px in jpg o png',
        TasksDisplay: 'Visualizzazione attività',
        TaskIndex: 'Attività {{index}}',
        TaskDoneBadge: 'Badge attività completata',
        TaskDoneBadgeHelpText: 'l: 130px &times; a: 130px',
        TaskHeadline: 'Titolo attività',
        TaskSubHeadline: 'Sottotitolo attività',
        TaskIcon: 'Icona attività',
        ButtonText: 'Testo bottone',
        ButtonExternalLink: 'Link esterno bottone'
      },

      QuizQuestions: {
        Title: 'Domande',
        AddQuestion: 'Aggiungi domanda',
        Type: 'Tipo',
        TextQuestion: 'Domanda testuale',
        ImageQuestion: 'Domanda con immagine',
        WrittenResponse: 'Risposta scritta',
        MultipleAnswers: 'Risposte multiple',
        SingleAnswer: 'Risposta singola',
        Question: 'Domanda',
        Required: 'Obbligatorio',
        Actions: 'Azioni',
        Edit: 'Modifica',
        Delete: 'Elimina',

        EditQuestion: 'Modifica domanda',
        UpdateQuestion: 'Aggiorna domanda',
        Cancel: 'Annulla',
        QuestionType: 'Tipo di domanda',
        TextChoice: 'Scelta testuale',
        ImageChoice: 'Scelta immagine',
        CharactersLeft: 'caratteri rimasti',
        Description: 'Descrizione',
        ImageHelpText: 'l: 360px &times; a: 145px | Consentiti: .jpg, .jpeg, .png, .svg',
        LabelForQuestionImage: "Etichetta per l'immagine della domanda",
        RequiredToAnswer: 'Risposta obbligatoria',
        RequiredToAnswerDescription:
          "I partecipanti al sondaggio potranno digitare la loro risposta in un'area di testo, come mostrato di seguito:",
        InputFieldExample: 'Esempio campo di inserimento',
        AllowSelectingMultipleAnswers: 'Consenti la selezione di più risposte',
        ChooseCorrectAnswer: 'Scegli la risposta corretta',
        IsSurveyChoice: 'Scelta n.{{index}}',
        AnswerChoice: 'Risposta n.{{index}}',
        Option: 'Opzione n.{{index}}',
        EachQuestionRequiresAtLeastTwoAnswers: 'Ogni domanda richiede almeno due risposte',
        AddAnother: "Aggiungi un'altra",
        Answer: 'risposta',

        ShowOthers: 'Mostra "Altro (specificare):"',
        Other: 'Altro (specificare):',

        RequiredField: 'Questo campo è obbligatorio!',
        YouNeedToTypeIn: 'Devi inserire',
        AnAnswer: 'una risposta',
        AQuestion: 'una domanda',
        OrUploadAnImage: "o caricare un'immagine",
        YouNeedToSelectMoreThanOneCorrectAnswer: 'Devi selezionare più di una risposta corretta',
        YouNeedToSelectAtLeastOneCorrectAnswer: 'Devi selezionare almeno una risposta corretta',
        PleaseTypeInYourAnswer: 'Per favore inserisci la tua risposta',
        Recommended: 'Consigliato: 720px per 120px | Consentiti: .jpg, .png, .svg',
        Upload: 'Carica'
      },

      QuizTimer: {
        Title: 'Timer quiz',
        SetATimeLimitForEachQuestion: 'Imposta un limite di tempo per ogni domanda',
        CountUp: 'Conteggio crescente',
        CountDown: 'Conteggio decrescente',
        MaximumCount: 'Conteggio massimo',
        MaximumCountPlaceholder: '∞',
        Seconds: 'Secondi'
      },

      QuizLimits: {
        Title: 'Limiti quiz',
        SurveyLimits: 'Limiti sondaggio',
        QuizLimits: 'Limiti quiz',
        AutoIssueMoves: 'Mosse di emissione automatica',
        TotalLimitsInTheCampaignIs: 'Il limite totale di {{campaingType}} nella campagna è',
        InfiniteUses: 'NOTA: Per usi illimitati, lascia il campo vuoto.',
        IndividualUsersCanOnlyAttemptThisQuiz:
          'Gli utenti possono tentare questo {{campaingType}} solo una volta',
        InfiniteUsers: 'NOTA: Per utenti illimitati, lascia il campo vuoto.',
        TimesInTotal: 'volte in totale',
        TimesPer: 'volte per',
        Day: 'giorno',
        Week: 'settimana',
        Month: 'mese',
        Year: 'anno',
        BlockUsersWhoAchieved100PercentCorrect:
          'Blocca gli utenti che hanno ottenuto il 100% di risposte corrette impedendo ulteriori tentativi',
        BlockUsersWhoAchieved100PercentCorrectNote:
          'NOTA: Una volta che un cliente risponde correttamente a tutte le domande di questo quiz, non potrà più rispondere al quiz, indipendentemente dai tentativi di gioco rimanenti.'
      },
      QuizValidity: {
        Survey: 'Sondaggio',
        Quiz: 'Quiz',
        Title: 'Validità {{campaingType}}',
        AfterIssueTheQuizWillExpireIn: "Dopo l'emissione, il/la {{campaingType}} scadrà in",
        QuizLimitPlaceholder: '100',
        Days: 'giorni',
        Months: 'mesi',
        Years: 'anni'
      },
      QuizGraphicsSettings: {
        Title: 'Proprietà quiz',
        AppBackground: 'Sfondo app',
        FontColour: 'Colore carattere',
        CTAButtonBackgroundColour: 'Colore sfondo pulsante CTA',
        CTAButtonTextColour: 'Colore testo pulsante CTA',
        HelpText: 'l: 375px &times; a: 812px'
      },
      MicrositeGraphicsSettings: {
        Title: 'Proprietà visualizzazione microsito',
        LandingScreen: 'Schermata iniziale',
        OutcomeSettings: 'Impostazioni risultato',
        Body: 'Corpo',
        InsertYouTubeEmbedURLHere: "Inserisci qui l'URL di embed di YouTube",
        ButtonText: 'Testo pulsante',
        OutcomeSettingsScoreResult: 'Impostazioni risultato',
        SuccessfulOutcomeHeadline: 'Titolo risultato positivo',
        SuccessfulOutcomeBody: 'Corpo risultato positivo',
        SuccessfulOutcomeImage: 'Immagine risultato positivo',
        SuccessfulOutcomeImageHelpText: 'l: 400px &times; a: 400px',
        SuccessfulOutcomeButton: 'Pulsante risultato positivo',
        NoOutcomeTitle: 'Titolo nessun risultato',
        NoOutcomeSubheadline: 'Sottotitolo nessun risultato',
        NoOutcomeImage: 'Immagine nessun risultato',
        NoOutcomeButton: 'Pulsante nessun risultato'
      },

      CampaignSelectModal: {
        Title: 'Seleziona una campagna',
        OkText: 'Aggiungi campagna',
        CancelText: 'Annulla',
        SearchPlaceholder: 'Trova una campagna per nome, tipo o commerciante',
        Name: 'Nome',
        Status: 'Stato',
        Tags: 'Tag',
        StartDate: 'Data inizio',
        EndDate: 'Data fine',
        Active: 'Attiva',
        Scheduled: 'Programmato',
        ID: 'ID'
      }
    },

    Outcomes: {
      SelectOutcomes: 'Seleziona risultati',
      Name: 'Nome',
      Action: 'Azione',
      EditPoints: 'Modifica punti',
      Remove: 'Rimuovi',
      EditReferralRule: 'Modifica regola referral',
      MoveToTop: 'Sposta in cima',
      MerchantName: 'Nome commerciante',
      SellingFrom: 'In vendita da',
      SellingTo: 'In vendita fino a',
      RewardBalance: 'Saldo premio',
      PointsAwarded: 'Punti assegnati',
      ReferrerLimits: 'Limiti referente',
      ReferralsNeeded: 'Referral necessari',
      RefereeRewardLimit: 'Limite premio referee',
      AwardBadges: 'Assegna badge',
      AwardPoints: 'Assegna punti',
      AddRewards: 'Aggiungi premi',
      ExpiresInDays: 'Expires in {{count}} days',
      AwardGameTry: 'Assegna tentativo di gioco',
      EditGameTry: 'Modifica tentativo di gioco',
      ReferrerGameTryIssued: 'Tentativo di gioco Referente',
      RefereeGameTryIssued: 'Tentativo di gioco Arbitro'
    },

    CampaignRules: {
      AddRule: 'Aggiungi regola'
    },

    RuleGroup: {
      Mechanic: 'Meccanica'
    },

    RefferalSelectionModal: {
      Title: 'Modifica regola referral',
      OnCancelError: 'Il valore del referral non è un numero! Per favore controllalo!',
      OkButtonText: 'OK',
      RewardId: 'ID premio:',
      Referee: 'Referee',
      Referrer: 'Referente',
      NoOfReferralsNeeded: 'N. di referral necessari',
      TotalRewardLimit: 'Limite totale premio',
      RewardLimit: 'Limite premio',
      RewardBalance: 'Saldo premio : ',
      CheckboxError: 'Le opzioni Referente o Referee sono obbligatorie',
      RewardIDTitle: 'ID Premio:',
      Points: 'Punti',
      Of: ' di ',
      TotalOutcomeLimit: 'Limite totale risultato',
      OutcomeLimit: 'Limite risultato',
      NumberError: 'Questo valore deve essere un numero',
      RequiredError: 'Questo valore è obbligatorio'
    },

    CampaignReferralRewardPickerModal: {
      SearchRewards: 'Cerca premi',
      Active: 'Attivo',
      Private: 'Privato',
      Approved: 'Approvato',
      System: 'Sistema',
      SelectRewards: 'Seleziona premi',
      Back: 'Indietro',
      Next: 'Avanti',
      Done: 'Fatto',
      Name: 'Nome',
      MerchantName: 'Nome commerciante',
      SellingFrom: 'In vendita da',
      SellingTo: 'In vendita fino a',
      RewardBalance: 'Saldo premio',
      SetupReferralRule: 'Configura regola referral'
    },

    RewardPicker: {
      SelectRewards: 'Seleziona premi',
      OkButtonText: 'Aggiungi premi',
      SearchRewards: 'Trova un nuovo premio per nome, tipo o commerciante',
      Active: 'Attivo',
      Private: 'Privato',
      Approved: 'Approvato',
      System: 'Sistema',
      Ended: 'Terminato',
      Inactive: 'Inattivo',
      Draft: 'Bozza',
      Name: 'Nome',
      MerchantName: 'Nome commerciante',
      SellingFrom: 'In vendita da',
      SellingTo: 'In vendita fino a',
      RewardBalance: 'Saldo premio'
    },

    CampaignReferralPointsModal: {
      PleaseSelectGLAccount: 'Seleziona un conto GL',
      PleaseSelectGLAccountTypeAndName: 'Seleziona un conto GL, Tipo e Nome',
      PleaseSetNumberOfPointsToAward: 'Imposta il numero di punti da assegnare',
      SetPointsToAward: 'Imposta punti da assegnare',
      Next: 'Avanti',
      Done: 'Fatto',
      SelectLoyaltyProgram: 'Seleziona programma fedeltà',
      HowManyPoints: 'Quanti punti?',
      SelectGLAccount: 'Seleziona conto GL',
      SelectGLAccountType: 'Seleziona tipo conto GL',
      SelectGLAccountName: 'Seleziona nome conto GL',
      SelectGLAccountNamePlaceholder: 'Nome',
      EnterPoints: 'Inserisci punti',
      SetupReferralRule: 'Configura regola referral',
      AwardedPointsExpireIn: 'Awarded points expire in',
      NumberOfDaysPlaceholder: 'e.g., 7',
      Days: 'days'
    },

    CampaignReferralGameTryModal: {
      SelectCampaigns: 'Seleziona campagne',
      SetupReferralRule: 'Configura regola referral',
      NumberOfGameTry: 'Numero di tentativi di gioco',
      WarningText:
        "Solo le campagne con l'emissione automatica di tentativi di gioco disabilitata possono essere selezionate per l'emissione di tentativi di gioco.",
      CampaignID: 'ID Campagna: {{id}}, {{name}}',
      Back: 'Indietro',
      Next: 'Avanti',
      Done: 'Fatto',
      SearchCampaigns: 'Cerca campagne',
      Active: 'Attivo',
      Scheduled: 'Programmato',
      Referee: 'Arbitro',
      Referrer: 'Referente',
      NoOfReferralsNeeded: 'Numero di referral necessari'
    },

    GameTypesSelectModal: {
      Title: 'Seleziona un tipo di gioco',
      OkButtonText: 'Seleziona',
      CancelButtonText: 'Annulla',

      ShakeTheTree: {
        Title: "Scuoti l'Albero",
        InstructionsLineOne:
          'Coinvolgi i clienti con una sfida che richiede di scuotere il telefono',
        InstructionsLineTwo: 'Meccaniche di gioco',
        InstructionsLineThree:
          "1. L'utente finale ottiene un premio completando un'azione richiesta, in questo caso scuotendo l'albero",
        InstructionsLineFour:
          '2. I premi vengono distribuiti casualmente in base alla probabilità impostata sui premi',
        InstructionsLineFive: 'Ideale per',
        InstructionsLineSix: '1. Gioco stagionale'
      },
      HitThePinata: {
        Title: 'Colpisci la Piñata',
        InstructionsLineOne: 'Coinvolgi i clienti con una sfida che richiede di colpire la piñata',
        InstructionsLineTwo: 'Meccaniche di gioco',
        InstructionsLineThree:
          "1. L'utente finale ottiene un premio completando un'azione richiesta, in questo caso colpendo la piñata",
        InstructionsLineFour:
          '2. I premi vengono distribuiti casualmente in base alla probabilità impostata sui premi',
        InstructionsLineFive: 'Ideale per',
        InstructionsLineSix: '1. Gioco stagionale'
      },
      ScratchCard: {
        Title: 'Gratta e Vinci',
        InstructionsLineOne:
          'Coinvolgi i clienti facendoli grattare per vincere premi entusiasmanti',
        InstructionsLineTwo: 'Meccaniche di gioco',
        InstructionsLineThree:
          "1. L'utente finale ottiene un premio completando un'azione richiesta, in questo caso grattando la carta",
        InstructionsLineFour:
          '2. I premi vengono distribuiti casualmente in base alla probabilità impostata sui premi',
        InstructionsLineFive: 'Ideale per',
        InstructionsLineSix: '1. Gioco stagionale'
      },
      SpinTheWheel: {
        Title: 'Gira la Ruota',
        InstructionsLineOne:
          'Coinvolgi i clienti facendoli girare la ruota per vincere premi entusiasmanti',
        InstructionsLineTwo: 'Meccaniche di gioco',
        InstructionsLineThree:
          "1. L'utente finale ottiene un premio completando un'azione richiesta, in questo caso girando la ruota",
        InstructionsLineFour:
          '2. I premi vengono distribuiti casualmente in base alla probabilità impostata sui premi',
        InstructionsLineFive: 'Ideale per',
        InstructionsLineSix: '1. Gioco stagionale'
      },
      Plinko: {
        Title: 'Plinko',
        InstructionsLineOne:
          'Coinvolgi i clienti facendoli tentare la fortuna per far cadere la palla nello slot vincente',
        InstructionsLineTwo: 'Meccaniche di gioco',
        InstructionsLineThree:
          "1. L'utente finale ottiene un premio completando un'azione richiesta, in questo caso facendo cadere la palla",
        InstructionsLineFour:
          '2. I premi vengono distribuiti casualmente in base alla probabilità impostata sui premi',
        InstructionsLineFive: 'Ideale per',
        InstructionsLineSix: '1. Gioco stagionale'
      },
      BubblePop: {
        Title: 'Scoppia le bolle',
        InstructionsLineOne:
          'Coinvolgi i clienti con una sfida divertente e veloce che premia davvero',
        InstructionsLineTwo: 'Meccaniche di gioco',
        InstructionsLineThree:
          '1. L’utente guadagna punti toccando bolle colorate entro 30 secondi',
        InstructionsLineFour:
          '2. Ogni colore di bolla vale un diverso punteggio positivo o negativo — scoppiale con saggezza',
        InstructionsLineFive:
          '3. In base al punteggio finale, gli utenti vengono ricompensati istantaneamente con punti fedeltà, buoni, tentativi di gioco o biglietti della lotteria',
        InstructionsLineSix:
          '4. Più alto è il punteggio, migliore è la ricompensa — pura abilità, nessuna fortuna',
        InstructionsLineSeven: 'Ideale per',
        InstructionsLineEight:
          'Campagne in cui vuoi premiare il coinvolgimento, non solo la fortuna'
      },
      ClawMachine: {
        Title: 'Macchina ad artiglio',
        InstructionsLineOne:
          'Un gioco divertente che unisce abilità e fortuna. Sfida i tuoi clienti a prendere il premio che desiderano prima che scada il tempo!',
        InstructionsLineTwo: 'Meccaniche di gioco',
        InstructionsLineThree:
          '1. Gli utenti muovono il braccio a sinistra e a destra per posizionarlo sopra il premio che desiderano.',
        InstructionsLineFour:
          '2. Premi il pulsante ‘Afferra’ per tentare di prendere il premio prima che scada il tempo.',
        InstructionsLineFive: '3. Se l’operazione riesce, l’utente ottiene il premio.',
        InstructionsLineSix: 'Ideale per',
        InstructionsLineSeven:
          'Campagne di coinvolgimento ricorrente, blind box o per incentivare gli utenti a riscattare i loro punti per avere la possibilità di vincere un premio'
      }
    },

    StreakTypesSelectModal: {
      SelectStreakCampaignType: 'Seleziona il tipo di campagna Streak',
      ContinuousLoop: 'Ciclo continuo',
      Progressive: 'Progressivo',
      CheckIn: 'Registrazione',
      MilestoneBased: 'Basata su traguardi',
      TransactionCount: 'Conteggio transazioni',
      CumulativeSpend: 'Spesa cumulativa',
      ContinuousLoopDescription:
        'Mantieni i clienti coinvolti facendo loro svolgere attività ripetute entro un periodo di tempo fisso, ricevendo una ricompensa ogni volta.',
      GameMechanicsTitle: 'Meccaniche di gioco',
      ContinuousLoopGameMechanicsLineOne:
        '1. Il gioco è impostato su un periodo fisso: giornaliero, settimanale o mensile.',
      ContinuousLoopGameMechanicsLineTwo:
        '2. Gli utenti devono completare un’attività specifica più volte durante il periodo di gioco. Al completamento, ricevono la ricompensa e la campagna ricomincia automaticamente nel periodo successivo.',
      IfCustomersMissAStreakTheyStartAgainAtTheNextStreakPeriod:
        '3. Se i clienti interrompono una serie, ricominciano dal periodo di serie successivo.',
      ContinuousLoopIdealForTitle: 'Ideale per',
      ContinuousLoopIdealForLineOne: '1. Campagne di accesso giornaliero',

      MilestoneBasedDescription:
        'Imposta obiettivi progressivi per i clienti che devono eseguire attività ripetute, con un premio assegnato per ogni traguardo raggiunto.',
      MilestoneBasedGameMechanicsTitle: 'Meccaniche di gioco',
      MilestoneBasedGameMechanicsLineOne:
        '1. Il gioco è impostato su un intervallo fisso: giornaliero, settimanale o mensile.',
      MilestoneBasedGameMechanicsLineTwo:
        '2. Il gioco prevede un’attività definita che gli utenti devono ripetere, ad esempio: accedere, eseguire una transazione, ecc.',
      MilestoneBasedGameMechanicsLineThree:
        '3. Definisci i traguardi in base a quante attività devono essere completate e per quanti periodi consecutivi.',
      MilestoneBasedGameMechanicsLineFour:
        '4. I clienti ricevono un premio ogni volta che raggiungono il traguardo. Se saltano una serie, ricominciano dal traguardo attuale. I premi vengono assegnati solo una volta per traguardo.'
    },
    TeamsMechanics: {
      Title: 'Meccaniche di squadra',
      Description:
        'Le impostazioni delle meccaniche di squadra non possono essere aggiornate dopo la pubblicazione di una campagna.',
      ActivateTeamMechanics: 'Attiva meccaniche di squadra',
      TeamSize: 'Utenti per squadra',
      LandingScreen: 'Schermata iniziale',
      Image: 'Immagine',
      ImageHelpText: 'Dimensione minima 360(l) x 144(h) px in jpg o png',
      PreEnrollmentMessage: 'Messaggio pre-iscrizione',
      StampsEarnMessage: 'Messaggio guadagno timbri',
      GameplayInstructions: 'Istruzioni di gioco',
      JoinTeamPage: 'Pagina unisciti alla squadra',
      JoinTeamInfoMessage: 'Messaggio info unisciti alla squadra',
      InviteMemberMessage: 'Messaggio invito membro',
      InviteCodeBlurb: 'Testo codice invito',
      CharactersUsed: 'Caratteri utilizzati',
      Note: 'Nota',
      NoteDescriptionOne: 'Sia il',
      NoteDescriptionTwo: 'messaggio di invito membro',
      NoteDescriptionThree: 'che il',
      NoteDescriptionFour: 'testo del codice invito',
      NoteDescriptionFive:
        'sono usati per generare il "messaggio di condivisione". Non abbiamo posto limiti alla lunghezza di questo messaggio - ma tieni presente che i messaggi SMS hanno un limite di 160 caratteri per messaggio',

      DefaultPreEnrollmentMessagePartOne: 'Crea o unisciti a una squadra di {{teamSize}} membri',
      DefaultPreEnrollmentMessagePartTwo: 'Puoi creare o unirti a 1 squadra.',
      DefaultStampsEarnMessagePartOne: 'Guadagna timbri facendo una delle seguenti azioni',
      DefaultStampsEarnMessagePartTwo: 'Fai KYC',
      DefaultStampsEarnMessagePartThree: 'Passa agli estratti conto elettronici',
      DefaultParticipationInfoMessagePartOne: 'Guadagna premi facendo una delle seguenti azioni',
      DefaultParticipationInfoMessagePartTwo: 'Fai KYC',
      DefaultParticipationInfoMessagePartThree: 'Passa agli estratti conto elettronici',
      DefaultTeamCompleteButtonText: 'Controlla i tuoi progressi',
      DefaultTeamCompleteButtonTextStamp: 'Vedi le tue carte timbri',
      DefaultTeamIncompleteButtonText: 'Unisciti a una Squadra',
      DefaultTeamIncompleteButtonTextSecondary: 'Crea una Squadra',
      DefaultJoinTeamPageDescriptionPartOne:
        'Una squadra è considerata attiva solo quando {{teamSize}} membri si sono impegnati a unirsi.',
      DefaultJoinTeamPageDescriptionPartTwo:
        'Inserisci il codice/url nel campo sopra e clicca su unisciti',
      DefaultJoinTeamPageDescriptionPartThree:
        'Attendi finché {{teamSize}} membri si sono impegnati',
      DefaultJoinTeamPageDescriptionPartFour: 'Raccogli timbri come squadra',
      DefaultJoinTeamPageDescriptionPartFive: 'Gioca come squadra',
      DefaultJoinTeamPageDescriptionPartSix:
        'Gli individui possono far parte di una sola squadra (sia creata che unita)',
      DefaultInviteMessageDescriptionPartOne: 'Ciao, unisciti alla mia squadra per',
      DefaultInviteMessageDescriptionPartTwo: ' completare carte timbri ',
      DefaultInviteMessageDescriptionPartThree: ' giocare ',
      DefaultInviteMessageDescriptionPartFour: ' e vincere premi insieme!',
      DefaultInviteMessageCodeBlurb: 'Usa il mio codice squadra:'
    },

    EnrolMechanics: {
      EnrolmentMechanics: 'Meccaniche di iscrizione',
      AutoEnrolUsers: 'Iscrizione automatica utenti',
      EnrollableUntil: 'Iscrivibile fino al',
      AutoFillStamps: 'Riempimento automatico timbri',
      EnableCampaignDurationMechanics: 'Abilita meccaniche durata campagna',
      UsersMustCompleteTheCampaignWithin: 'Gli utenti devono completare la campagna entro',
      AutoRedeemOutcome: 'Riscatto automatico risultato',
      SendMicrositeNotification: 'Inviare notifica microsite per il riscatto automatico?',
      Yes: 'Sì',
      No: 'No'
    },

    StreakMechanics: {
      StreakMechanics: 'Meccaniche della serie',
      SelectTaskType: 'Seleziona il tipo di attività',
      CumulativeSpend: 'Spesa cumulativa',
      TransactionCount: 'Conteggio transazioni',
      SignIn: 'Accesso',
      StreakRequirements: 'Requisiti della serie',
      TargetCriteria: 'Criteri obiettivo',
      UserMustPerformTheTask: "L'utente deve eseguire l'attività",
      TimesWithinOne: 'volte entro 1',
      StreakTarget: 'Obiettivo serie',
      Continuous: 'consecutivi',
      Days: 'giorni',
      Weeks: 'settimane',
      Months: 'mesi',
      SelectTrigger: 'Seleziona il trigger',
      MilestonesAndPrizes: 'Traguardi e premi',
      TargetMake: 'Obiettivo: effettuare',
      ValidTransactionsEvery: 'transazioni valide ogni',
      For: 'per',
      Level: 'Livello',
      MustBeMoreThanLevel: 'deve essere superiore al livello',
      SelectStreakDuration: 'Seleziona la durata della serie',
      Daily: 'Giornaliero',
      Weekly: 'Settimanale',
      Monthly: 'Mensile',
      AtLeastOneConditionIsRequired: 'È richiesta almeno una condizione',
      CustomerSignIn: 'Accesso cliente',
      TransactionCreated: 'Transazione creata',
      TargetSpend: 'Obiettivo: Spesa',
      CurrencyEvery: 'valuta ogni',
      TargetSignIn: 'Obiettivo: Accesso',
      TimesEvery: 'volte ogni',
      Perform: 'eseguire',
      Signin: 'accedi',
      Transaction: 'transazione',
      Spend: 'spendere',
      PerformTheTask: 'eseguire il compito',
      InOrderToWinThePrize: 'per vincere il premio',
      MakeTransactionAtLeast: 'effettuare una transazione almeno',
      Times: 'volte',
      AtLeast: 'almeno',
      Where: 'dove',
      CurrencyOnTransactionsWhere: 'valuta, sulle transazioni in cui',
      MakeTransaction: 'effettuare una transazione'
    },

    LandingPage: {
      Title: 'Pagina di destinazione',
      Headline: 'Titolo',
      SubHeadline: 'Sottotitolo',
      BodyText: 'Testo corpo',
      Image: 'Immagine',
      CTAButtonText: 'Testo pulsante CTA',
      CTAButtonColour: 'Colore pulsante CTA',
      CTAButtonTextColour: 'Colore testo pulsante CTA',
      TermsAndConditions: 'Termini e condizioni',

      EnrolmentMessage: 'Messaggio di iscrizione',
      ImageHelpText: 'Rapporto 16:9 consigliato, massimo 500kb in jpg o png',
      IssuePrizeDescription: 'Descrizione premio emesso',
      IssuePrizeDescriptionPlaceholder: 'Inserisci la descrizione del premio emesso',
      PleaseInputYourHeadline: 'Inserisci il tuo titolo',
      PleaseInputYourSubHeadline: 'Inserisci il tuo sottotitolo',
      PleaseInputYourBodyText: 'Inserisci il testo del corpo',
      ImageMinRequirements: 'Dimensione minima 360(l) x 144(a) px in jpg o png',
      AspectRatioRecommendation: 'Rapporto 16:9 consigliato, massimo 500 KB in jpg o png',

      LevelsTab: "Scheda 'Livelli'",
      HowToParticipateTab: "Scheda 'Come partecipare'",
      TabName: 'Nome scheda',
      CampaignPointsShortForm: 'Abbreviazione punti campagna',
      LevelProgressBadges: 'Badge di avanzamento livello',
      LevelCompletedBadge: "Badge 'Livello completato'",
      LevelInProgressBadge: "Badge 'Livello in corso'",
      LevelNotStartedBadge: "Badge 'Livello non iniziato'",
      LevelCompletedBadgeHelpText: 'Consigliato 92px per 92px, massimo 100kb in jpg o png',
      IssuePrizelabel: "Descrizione 'Premio emesso'",
      LevelCompletedBadgeIcon: 'Icona livello {{index}}',
      Text: 'Testo',

      CompleteLevelAndStandToWinAPrizeSetIncluding:
        'Completa il livello e potrai vincere un set premio che include:',
      ParticipateAndWinExcitingPrizes: 'Partecipa e vinci premi entusiasmanti!',
      HowToParticipate: 'Come partecipare',
      AddLevel: 'Aggiungi livello',
      PointsRequiredForCampaignCompletion: 'Punti richiesti per completare la campagna:',

      OutcomeSettings: {
        Title: 'Impostazioni risultato',
        Badges: 'Badge',
        Vouchers: 'Voucher',
        Points: 'Punti',
        PrizeSet: 'Set premio',
        MixedRewards: 'Premi misti',
        Submit: 'Invia',
        MixedRewardsButtonText: 'Testo pulsante basato sul primo premio elencato',
        Headline: 'Titolo',
        CharactersLeft: 'caratteri rimasti',
        MixedRewardsMessage:
          'Per un set premio, il testo e l’azione del pulsante saranno basati sul primo premio elencato nei risultati.',
        ButtonText: 'Testo pulsante',
        Graphic: 'Grafica',
        GraphicHelpText: 'l: 400px × a: 400px',

        BadgesHeadline: 'Congratulazioni! Hai vinto un badge!',
        BadgesButtonText: 'Mostra i miei badge',
        VouchersHeadline: 'Congratulazioni! Hai vinto un voucher!',
        VouchersButtonText: 'Vai ai miei voucher',
        PointsHeadline: 'Congratulazioni! Hai vinto dei punti!',
        PointsButtonText: 'Vedi i miei punti',
        MixedRewardsHeadline: 'Congratulazioni! Hai vinto dei premi!',
        GameTries: 'Tentativi di gioco',
        GameTriesHeadline: 'Hai vinto dei tentativi di gioco per {campaign_name}!',
        GameTriesButtonText: 'Gioca ora',
        NoOutcome: 'Nessun risultato',
        NoOutcomeHeadline: 'Non hai vinto nulla. Ritenta, sarai più fortunato.',
        PlayAgainButtonText: 'Gioca ancora',
        ClawVouchersHeadline: 'Congratulazioni. Hai vinto un voucher!',
        ClawPointsHeadline: 'Congratulazioni. Hai vinto dei punti!',
        ClawBadgesHeadline: 'Congratulazioni. Hai vinto un badge!'
      },

      EndsOnDate: 'Termina il {{date}}',
      FromDate: 'Dal {{date}} in poi',
      ParticipateAndStandToWin: 'Partecipa e potrai vincere UNO dei seguenti:',
      CongratsYouEarnedAPrize: 'Congratulazioni, hai guadagnato un premio!',
      ClaimNowBeforeTheRunOut: 'Richiedili ora prima che finiscano!',
      ClaimPrize: 'RICHIEDI PREMIO',

      Levels: 'Livelli',
      PointsAbbreviation: 'CP'
    },

    StampCampaign: {
      Config: {
        Title: 'Seleziona Numero di Timbri',
        TotalStampsOnCard: 'Totale timbri sulla carta',
        TotalStamps: 'Totale timbri',
        StampsPerRow: 'N. di timbri per riga (max 5)',
        StampsPerRowPlaceholder: '(Opzionale) Specifica timbri per riga',
        StampsPerColumn: 'N. di timbri per colonna',
        StampsPerColumnPlaceholder: '(Opzionale) Specifica timbri per colonna'
      },
      TriggerConfig: {
        Title: 'Imposta regole guadagno timbri'
      },
      CardBackground: {
        Title: 'Immagine Carta',
        HeaderMessage: 'Messaggio intestazione',
        Subheadline: 'Sottotitolo',
        Backgrounds: 'Sfondi',
        BackgroundImage: 'Immagine sfondo',
        RemoveImage: 'Rimuovi immagine',
        BrowseFiles: 'SFOGLIA FILE',
        CardBackgroundImage: 'Immagine sfondo carta',
        CardBackgroundImageAlt: 'Sfondo carta timbri',
        ThumbnailImage: 'Immagine miniatura',
        ThumbnailImageAlt: 'Miniatura timbro',
        Elements: 'Elementi',
        GiftActive: 'Regalo (Attivo)',
        GiftActiveAlt: 'Regalo',
        GiftInactive: 'Regalo (Inattivo)',
        GiftInactiveAlt: 'Regalo (Inattivo)',
        StampActive: 'Timbro (Attivo)',
        StampActiveAlt: 'Timbro',
        StampInactive: 'Timbro (Inattivo)',
        StampInactiveAlt: 'Timbro (Inattivo)',
        ButtonText: 'Testo pulsante',
        ButtonExternalLink: 'Link esterno pulsante',
        ButtonColour: 'Colore pulsante',
        ButtonTextColour: 'Colore testo pulsante'
      },
      LimitConfig: {
        Title: 'Limiti Timbri',
        TotalStampCards: 'Totale carte timbri',
        TotalStampCardsPerUser: 'Totale carte timbri per utente',
        TotalStampsPerUser: 'Totale timbri per utente',
        TotalStamps: 'Totale timbri',
        Every: 'ogni',
        Days: 'Giorni',
        Months: 'Mesi',
        Year: 'Anno',
        Weeks: 'Settimane'
      },

      AutoEnrolMechanic: {
        Title: 'Meccaniche di iscrizione automatica',
        OperatingDays: 'Giorni operativi',
        From: 'Da',
        To: 'A'
      }
    },

    Referral: {
      Title: 'Tipi di codice referral',
      CodeType: 'Tipo codice',
      ReferredBy: 'Riferito da',
      SelectFile: 'Seleziona file',
      SystemGenerated: 'Generato dal sistema',
      AlternateId: 'ID alternativo',
      User: 'Utente',
      Partner: 'Partner',
      ActionMechanics: 'Meccaniche azione',

      UploadSingleFileFiled: {
        AcceptedFormat: 'Formati accettati: solo file {{acceptedFormatsString}}',
        DownloadSample: 'Scarica esempio',
        ChooseFile: 'Scegli file'
      }
    },

    CampaignRulesTable: {
      Outcome: 'Risultato',
      Priority: 'Priorità',
      TriggerLimitPerUser: 'Limite trigger per utente',
      TotalTriggerLimit: 'Limite trigger totale',

      Name: 'Nome',
      CampaignPointsIssued: 'Punti campagna emessi',
      Action: 'Azione',
      Edit: 'Modifica',
      Remove: 'Rimuovi'
    },

    RuleGroupLandingPage: {
      Title: 'Pagina di atterraggio',
      Headline: 'Titolo principale',
      HeadlinePlaceholder: 'Inserisci il tuo titolo principale',
      SubHeadline: 'Sottotitolo',
      SubHeadlinePlaceholder: 'Inserisci il tuo sottotitolo',
      BodyText: 'Testo principale',
      Image: 'Immagine',
      ImageHelpText: 'Rapporto consigliato 16:9, massimo 500kb in jpg o png',
      ExpandableContentSections: 'Sezioni di contenuto espandibili',
      SectionLabel: 'Etichetta sezione {{index}}',
      SectionHeaderText: 'Testo intestazione sezione {{index}}',
      SectionBodyText: 'Testo principale sezione {{index}}',

      ExpandableSection: 'Sezione espandibile',
      Label: 'Etichetta',
      AddSection: 'Aggiungi sezione',
      Remove: 'Rimuovi',

      ShopChooseRedeem: 'Acquista. Scegli. Riscatta.'
    },

    RuleGroupEnrolmentPage: {
      Title: 'Pagina di iscrizione',
      BodyText: 'Testo principale'
    },

    GameSettings: {
      ShakeTheTreeSettings: 'Impostazioni di Shake The Tree',
      HeaderMessage: 'Messaggio intestazione',
      Header: 'Intestazione',
      CharactersLeft: 'caratteri rimasti',
      HeadlineTextColour: 'Colore del testo dell’intestazione',
      Subheadline: 'Sottotitolo',
      Description: 'Descrizione',
      GameDesign: 'Design del gioco',
      BackgroundImage: 'Immagine di sfondo',
      TreeImage: 'Immagine dell’albero',
      GiftIcon: 'Icona regalo',
      GiftIconOpenState: 'Icona regalo - stato aperto',
      NumberOfGiftIcons: 'Numero di icone regalo',
      SubheadlineTextColour: 'Colore del testo del sottotitolo',
      NumberOfTaps: 'Numero di tocchi',
      PinataSettings: 'Paramètres de Pinata',
      AppBackground: 'Sfondo dell’app',
      FontColour: 'Colore del carattere',
      InitialPinata: 'Pignatta iniziale',
      CrackingPinata: 'Pignatta in rottura',
      BrokenPinata: 'Pignatta rotta',
      ButtonText: 'Testo del pulsante',
      ButtonColour: 'Colore del pulsante',
      ButtonTextColour: 'Colore del testo del pulsante',
      ClawMachineSettings: 'Impostazioni del gioco',
      DummyPrizeIcon: 'Icona premio fittizio (riempimento)',
      ArmAccuracy: 'Precisione della pinza',
      PrizeBoxImage: 'Icona del premio',
      GameBackgroundColour: 'Colore di sfondo del gioco',
      WidescreenImage: 'Immagine widescreen',
      DisplayProperties: 'Proprietà di visualizzazione',
      Headline: 'Titolo',
      AppGraphics: 'Grafica dell’app',
      ScratchCardGraphics: 'Grafica del Gratta e Vinci',
      PreScratch: 'Prima del gratta',
      PostSuccess: 'Dopo (Successo)',
      PostFail: 'Dopo (Fallimento)',
      SubheadlineColour: 'Colore del sottotitolo',
      ScratchCardHeadline: 'Titolo del Gratta e Vinci',
      SpinTheWheelHeadline: 'Titolo di Spin The Wheel',
      SpinTheWheelGraphics: 'Grafica di Spin The Wheel',
      RewardIcon: 'Icona ricompensa',
      NumberOfWedges: 'Numero di spicchi',
      NumberOfWedgesOnTheWheel: 'Numero di spicchi sulla ruota',
      Wedge: 'Spicchio',
      Color: 'Colore',
      HasReward: 'Contiene una ricompensa',
      RimImage: 'Immagine del bordo',
      WheelPosition: 'Posizione della ruota',
      WedgeTextColour: 'Colore del testo del segmento',
      Center: 'Centro',
      Bottom: 'Parte inferiore',
      PointerImage: 'Immagine del puntatore',
      PlinkoSettings: 'Impostazioni di Plinko',
      Plinko: 'Plinko!',
      PlinkoGraphics: 'Grafica di Plinko',
      FrameColour: 'Colore della cornice',
      BallColour: 'Colore della pallina',
      GameDuration: 'Durata del gioco',
      HowLongItTakesForTheBallToReachTheBottom:
        'Tempo necessario perché la pallina raggiunga il fondo',
      Seconds: 'secondi',
      SuggestedDuration: 'Durata consigliata: 3–5 secondi',
      TargetType: 'Tipo di bersaglio',
      Bubble: 'Bolla',
      Coins: 'Monete',
      Stars: 'Stelle',
      BubbleSpawnRate: 'Velocità di generazione delle bolle',
      Easy: 'Facile',
      Medium: 'Medio',
      Hard: 'Difficile',
      CTAButtonText: 'Testo del pulsante CTA',
      CTAButtonColour: 'Colore del pulsante CTA',
      CTAButtonTextColour: 'Colore del testo del pulsante CTA',
      NumberOfBubbles: 'Grafica Bubble Pop',
      BubbleLabel: 'Bolla',
      GameSettings: 'Impostazioni Bubble Pop',
      GameBackground: 'Sfondo del gioco',
      WedgeContents: 'Contenuto del segmento',
      Text: 'Testo',
      Image: 'Immagine',
      RewardBalance: 'Saldo ricompense',
      CustomSpawnRate: 'Tasso di generazione personalizzato',
      MaxBubbles: 'Max Bolle',
      SpawnInterval: 'Intervallo di generazione (in millisecondi)',
      BubblesPerSpawn: 'Bolla per spawn',
      BubbleLifetime: 'Durata della bolla (in millisecondi)',
      GameDurationNote: 'NOTA: È richiesta una durata minima del gioco di 10 secondi.',
      MaxBubblesNote: 'NOTA: Numero massimo di bolle da visualizzare sullo schermo.',
      SpawnIntervalNote: 'NOTA: intervallo di generazione delle bolle in millisecondi',
      BubblesPerSpawnNote: 'NOTA: Numero di bolle generate contemporaneamente.',
      BubbleLifetimeNote: 'NOTA: Durata della bolla in millisecondi',
      Type: 'Tipo',
      CustomImage: 'Immagine personalizzata',
      SVGCode: 'Codice SVG',
      DownloadSampleSVG: 'Scarica SVG di esempio',
      Points: 'Punti',
      MarkAsBonus: 'Segna come bonus',
      BonusImageOccurrence: "Nombre d'occurrences de Bolla bonus"
    },

    OutcomeSettings: {
      OutcomeSettings: 'Impostazioni dei risultati',
      WinRewardTitle: 'Titolo della ricompensa vinta',
      CharactersLeft: 'caratteri rimasti',
      WinRewardSubheadline: 'Sottotitolo della ricompensa vinta',
      WinRewardGraphic: 'Grafica della ricompensa vinta',
      NoOutcomeTitle: 'Titolo senza risultato',
      NoOutcomeSubheadline: 'Sottotitolo senza risultato',
      NoOutcomeGraphic: 'Grafica senza risultato',
      WinRewardButton: 'Pulsante della ricompensa vinta',
      NoOutcomeButton: 'Pulsante senza risultato'
    },

    GameLimits: {
      GameLimits: 'Limiti del gioco',
      AutoIssueMoves: 'Mosse automatiche',
      AlwaysShowThisCampaignEvenIfOutOfGameTries:
        'Mostra sempre questa campagna anche se i tentativi di gioco sono esauriti',
      TotalGameCampaignLimitsIs: 'Il limite totale della campagna di gioco è',
      NoteForInfiniteUsesLeaveBlank: 'NOTA: per usi illimitati, lascia il campo vuoto.',
      IndividualUsersCanOnlyPlayThisGame: 'Gli utenti possono giocare a questo gioco solo',
      TimesInTotal: 'volte in totale',
      TimesPer: 'volte per'
    }
  },

  [CampaignReviewPageKey]: {
    GameInfoTitle: 'Info gioco',

    GameInfo: {
      NumberOfTaps: 'Numero di tap:',
      NumberOfGiftsShown: 'Numero di icone regalo:',
      NumberOfGiftsToDrop: 'Numero di icone regalo da far cadere:',
      CampaignLifetimeMaxMovesAvailable: 'Limiti totali campagna gioco:',
      AccountLifetimeMaxMovesAvailable:
        'Gli utenti individuali possono giocare questo gioco volte:',
      AccountIntervalMaxMovesAvailable: 'Gli utenti individuali possono giocare questo gioco:',
      Times: 'volte',
      Per: 'per'
    },

    CampaignRequestComment: {
      Content: 'Contenuto',
      DeleteButton: 'Pulsante elimina',
      Delete: 'Elimina',
      Time: 'Ora',

      Title: 'Campagna in attesa',

      Description:
        'Questa campagna è in attesa di approvazione. Eventuali commenti aggiunti appariranno qui.',
      CommentsAdded: 'commenti aggiunti',
      PointsExpiryUnit: 'Scadenza punti (giorni)',
      PointsExpiryPeriod: 'Periodo di scadenza punti'
    },

    DeleteCommentModal: {
      SuccessMessage: 'Commento eliminato',
      ErrorMessage: "Errore durante l'eliminazione del commento",
      Title: 'Eliminare il commento?',
      OkText: 'Elimina',
      DescriptionLineOne: 'Sei sicuro di voler eliminare questo commento?',
      DescriptionLineTwo: 'Questa azione non può essere annullata.',
      CancelText: 'Annulla'
    },

    ApproveDenyCampaignRequestModalTitle: 'Approvare la campagna?',
    ApproveDenyCampaignRequestModalButton: 'Approva',

    ApproveDenyCampaignRequestModal: {
      SuccessMessage: 'La richiesta è stata approvata',
      ErrorMessage: 'Qualcosa è andato storto',
      ErrorTitle: 'Approvazione non riuscita',

      ApproveTitle: 'Approvare la campagna?',
      Title: 'Inviare richiesta di eliminazione?',
      ApproveOkText: 'Approva',
      OkText: 'Richiedi eliminazione',
      CancelText: 'Annulla',

      ApproveDescriptionLineOne: 'Sei sicuro di voler approvare questa campagna?',
      ApproveDescriptionLineTwo: 'Questa azione non può essere annullata.',

      DescriptionLineOne:
        'Questa campagna è in attesa di approvazione. Sei sicuro di volerla eliminare?',
      DescriptionLineTwo:
        "Una volta approvata l'eliminazione, questa campagna non sarà più disponibile e dovrai crearla di nuovo."
    },

    AddCommentModalTitle: 'Visualizza e aggiungi commenti',
    AddCommentModalButton: 'Aggiungi Commento',
    AddCommentModal: {
      SuccessMessage: 'Commento aggiunto',
      ErrorMessage: "Errore durante l'aggiunta del commento",
      CancelText: 'Annulla',
      CommentInputPlaceholder: 'Inserisci il tuo commento qui',
      AddCommentButton: 'Aggiungi commento'
    },

    CampaignInfoTitle: 'Info campagna',

    ReviewInfo: {
      Subtitle: 'Sottotitolo:',
      Description: 'Descrizione:',
      TnC: 'Termini e condizioni:',
      RiskDisclaimer: 'Disclaimer sui rischi:',
      BranchName: 'Nome del marchio:',
      Tags: 'Tag:',
      Categories: 'Categorie:',
      Labels: 'Etichette:',
      Catalogue: 'Cataloghi:',
      UploadImages: 'Foto caricate:',
      Merchant: 'Commerciante:',
      CustomField: 'Campi personalizzati:',
      Type: 'Tipo:',
      Url: 'URL sito web:',
      Partner: 'Partner:',
      Reset: 'Reimposta:',
      Stackable: 'Accumulabile:',
      Status: 'Stato:',
      Name: 'Nome campagna:',
      CatalogueName: 'Nome catalogo:',
      Duration: 'Durata campagna:',
      StepsToRedeem: 'Passi per riscattare:',
      ActiveAt: 'Attiva il:',
      Owner: 'Proprietario:',
      RewardLegacyAudience: 'Dove può essere mostrato questo premio:',
      RewardsCost: 'Costo premi:',
      SellingPrice: 'Prezzo di vendita:',

      OperatingDays: 'Giorni operativi:',
      OperatingPeriod: 'Periodo operativo:',

      ReviewMonth: 'Mese di revisione:',
      PromotionSettings: 'Impostazioni promozione:',
      DemotionSettings: 'Impostazioni declassamento:',
      PromoteUntil: 'Promozione fino al:'
    },

    SocialMediaReview: {
      CopyTextSuccessMessage: 'URL Social Media Copiato!',
      Title: 'Social Media',
      OGTitle: 'Titolo',
      OGDescription: 'Descrizione',
      OGImage: 'Immagine',
      OGImageAlt: 'Anteprima social media',
      AlternativeIOSLinkDescription: 'Link app iOS',
      AlternativeAndroidURLDescription: 'Link app Android',
      OGURL: 'Link Web',
      SocialMediaURL: 'URL Social Media',
      CopyURLButton: 'Copia URL',
      OGURLDescription: 'Questo link verrà generato solo dopo il lancio',
      WebLink: 'Link Web',
      Description: `Il campo {{webLink}} deve essere compilato per generare l'URL Social Media`
    },

    AudienceInfoTitle: 'Info Pubblico',

    AudienceInfo: {
      Description: 'Pubblico selezionato:',
      NoListsSelected: 'Nessuna lista selezionata',
      Include: 'Includi',
      Exclude: 'Escludi',
      AudienceAttributes: 'Attributi pubblico',
      AudienceList: 'Lista pubblico'
    },

    EnrolmentSettings: 'Impostazioni iscrizione',
    AutoEnrolUsers: 'Iscrizione automatica utenti',
    EnrollableUntil: 'Iscrivibile fino al',
    AutoRedeemOutcome: 'Riscatto automatico risultato',
    SendMicrositeNotificationAutoRedeem: 'Inviare notifica microsite per il riscatto automatico?',
    StampMechanics: 'Meccaniche timbri',
    TotalStampCards: 'Totale carte timbri',
    TotalStampCardsPerUser: 'Totale carte timbri per utente',
    TotalStamps: 'Totale timbri',
    TotalStampsPerUser: 'Totale timbri per utente',

    GameMechanics: {
      Title: 'Meccaniche di gioco',
      HitThePinata: {
        Title: 'Colpisci la Piñata',
        InstructionsLineOne:
          "1. L'utente finale ottiene un premio completando un'azione richiesta, in questo caso colpendo la piñata.",
        InstructionsLineTwo:
          '2. I premi vengono assegnati casualmente in base alla probabilità impostata sui premi',
        IdealFor: 'Ideale per',
        InstructionsLineThree: '1. Gioco stagionale',
        HeaderMessage: 'Messaggio intestazione',
        GameDesign: 'Design del gioco',
        PlayButtonText: 'Testo pulsante gioca'
      },

      ShakeTheTree: {
        Title: "Scuoti l'Albero",
        InstructionsLineOne:
          'Coinvolgi i clienti con una sfida che richiede di scuotere il telefono',
        GameMechanics: 'Meccaniche di gioco',
        InstructionsLineTwo:
          "1. L'utente finale ottiene un premio completando un'azione richiesta, in questo caso scuotendo il telefono",
        InstructionsLineThree:
          '2. I premi vengono assegnati casualmente in base alla probabilità impostata sui premi',
        IdealFor: 'Ideale per',
        InstructionsLineFour: '1. Gioco stagionale',
        HeaderMessage: 'Messaggio intestazione',
        GameDesign: 'Design del gioco',
        TreeVisual: 'Visuale albero',
        GiftVisual: 'Visuale regalo',
        PlayButtonText: 'Testo pulsante gioca'
      },

      BubblePop: {
        Title: 'Proprietà Bubble Pop',
        GameTitle: 'Gioco Bubble Pop',
        Description: 'Coinvolgi il cliente con le sue abilità.',
        BubbleSpawnRate: 'Tasso di generazione bolle',
        GameDuration: 'Durata del gioco',
        Seconds: 'secondi',
        GameBackground: 'Sfondo del gioco',
        NumberOfBubbles: 'Numero di bolle',
        BubbleColors: 'Colori delle bolle',
        Bubble: 'Bolla',
        CustomImage: 'Immagine personalizzata',
        Points: 'Punti',
        IsBonus: 'è bonus?',
        Yes: 'Sì',
        No: 'No',
        MaxBubbles: 'Max Bolle',
        SpawnInterval: 'Intervallo di generazione (in millisecondi)',
        BubblesPerSpawn: 'Bolla per spawn',
        BubbleLifetime: 'Durata della bolla (in millisecondi)',
        CustomSpawnRate: 'Tasso di generazione personalizzato'
      },

      QuizOrSurveyTypeGame: {
        Properties: 'Proprietà',

        GameMeta: {
          ScratchCard: 'Gratta e Vinci',
          ScratchCardDetails:
            'Coinvolgi i clienti con una sfida che richiede di grattare una carta da gioco.',
          HitThePinata: 'Colpisci la Piñata',
          HitThePinataDetails:
            'Coinvolgi i clienti con una sfida che richiede di scuotere il telefono.',
          ShakeTheTree: "Scuoti l'Albero",
          ShakeTheTreeDetails:
            "Coinvolgi i clienti con una sfida che richiede di toccare l'oggetto.",
          SpinTheWheel: 'Gira la Ruota',
          SpinTheWheelDetails: 'Coinvolgi il cliente con una ruota della fortuna.',
          Plinko: 'Plinko',
          PlinkoDetails: 'Fai cadere la palla e ottieni dei rimbalzi fortunati',
          ClawMachine: 'Macchina ad artiglio',
          ClawMachineDetails:
            'Coinvolgi i clienti con un artiglio che posizionano sopra un premio e abbassano per afferrarlo.',
          ArmAccuracy: 'Precisione della pinza',
          PrizeMode: 'Modalità di gioco',
          FixedPrizeMode: 'I clienti afferrano un premio fisso',
          RandomPrizeMode: 'Il cliente riceve un premio casuale (blindbox)'
        },

        GameGraphics: {
          AppGraphics: 'Grafica app',
          PreScratch: 'pre-grattaggio',
          PostSuccess: 'Post (successo)',
          PostFail: 'Post (fallimento)',
          RewardIcon: 'Icona premio',
          NumberOfWedges: 'Numero di spicchi',
          WedgeColors: 'Colori spicchi',
          Wedge: 'Spicchio',
          WheelImage: 'Immagine ruota',
          WheelPosition: 'Posizione ruota',
          PointerImage: 'Immagine indicatore',
          Headline: 'Titolo',
          Subheadline: 'Sottotitolo',
          AppBackground: 'Sfondo app',
          ButtonText: 'Testo pulsante',

          FrameColor: 'Colore cornice',
          BallColor: 'Colore palla',
          HeadlineTextColor: 'Colore testo titolo',
          SubheadlineTextColour: 'Colore testo sottotitolo',

          GameBackgroundColour: 'Colore di sfondo del gioco',
          ButtonColour: 'Colore del pulsante',
          ButtonTextColour: 'Colore del testo del pulsante',
          PrizeBoxImage: 'Immagine scatola premio',
          PrizeIcons: 'Icone dei premi',
          PrizeIconSlot: 'Posizione'
        },

        Survey: 'Sondaggio',
        SurveyDetails: 'Coinvolgi il cliente con domande a scelta multipla.',
        Quiz: 'Quiz',
        QuizDetails: 'Coinvolgi il cliente con domande a scelta multipla.',
        BackgroundImage: 'Immagine sfondo',
        Submit: 'Invia'
      }
    },

    RewardLimits: {
      Title: 'Limiti premio',
      DescriptionLineOne: 'Numero totale di premi che possono essere emessi:',
      DescriptionLineTwo: 'Numero di premi che ogni utente può ricevere:',
      DescriptionLineThree: 'Gli utenti individuali possono giocare questo gioco:',
      DescriptionLineFour: 'La campagna emetterà premi solo:',
      InTotal: 'in totale',
      Times: 'volte',
      Per: 'per'
    },

    Rules: 'Regole',

    RulePreview: {
      MoreOutcomes: '+{{count}} risultato/i in più',
      ID: 'ID',
      RulesBalance: 'Bilancio regole',
      Of: 'di',
      Trigger: 'Trigger',
      Type: 'Tipo',
      Conditions: 'Condizioni',
      EventName: 'Nome evento',
      CampaignId: 'ID campagna',
      RewardId: 'ID premio',
      LoyaltyId: 'ID fedeltà',
      LoyaltyTierId: 'ID livello fedeltà',
      AutomationTriggerId: 'ID trigger automazione',
      Outcome: 'Risultato',
      NumberOfStamps: 'Numero di timbri',
      AwardPoints: 'Assegna punti',
      ForEveryCurrency: 'Per ogni Valuta',
      UpToAMaximumOfPoints: 'Fino a un massimo di punti',
      UserEarnsOneRaffleTicket: "L'utente guadagna 1 biglietto della lotteria",
      UserEarnsRaffleTickets: "L'utente riceve {{x}} biglietto/i della lotteria",
      AwardRaffleTickets: 'Assegna {{x}} biglietto/i della lotteria',
      UpToAMaximumOfRaffleTickets: 'Fino a un massimo di {{z}} biglietto/i della lotteria',
      TheTaskWillBeMarkedAsDone: "Il compito sarà contrassegnato come 'completato'",
      Points: 'Punti',
      LoyaltyProgram: 'Programma fedeltà',
      Award: 'Premio',
      GlAccountNumber: 'Numero Conto GL',
      GlAccountName: 'Nome Conto GL',
      CostCenterId: 'ID Centro di Costo',
      BranchCode: 'Codice Filiale',
      Reward: 'Premio',
      Name: 'Nome',
      SellingFrom: 'In vendita da',
      Limits: 'Limiti',
      MaximumEvents: 'Eventi massimi',
      PerCampaign: 'per campagna',
      PerUser: 'per utente',
      TriggerRateLimit: 'Limite frequenza trigger',
      PerUserForEvery: 'per utente per ogni',
      SendPushNotificationLabel: 'Inviare una notifica push ad ogni attivazione della regola?:',
      Attribute: 'Attributo',
      Operator: 'Operatore',
      SelectedValues: 'Valori selezionati',
      Conditionals: 'Condizionali',
      Condition: 'Condizione',
      NA: 'N.D.',
      PushNotificationRuleForInstantOutcomeTransactionIssue:
        'Regola di notifica push per emissione di transazione a risultato istantaneo',
      PushNotificationRuleForAutoRedeemInstantOutcomeTriggers:
        'Regola di notifica push per i trigger di riscatto automatico a risultato istantaneo',
      CurrencyWithin1: 'valuta entro 1',
      UserMustPerform: "L'utente deve eseguire",
      UserMust: "L'utente deve",
      AtLeast: 'almeno',
      TimesWithin1: 'volte entro 1',
      StreakCampaignMechanics: 'Meccaniche della campagna a serie',
      SendPushNotificationForEveryRuleTrigger:
        'Inviare notifica push per ogni attivazione della regola?:',
      YES: 'SÌ',
      NO: 'NO',
      MediaTag: 'Tag multimediale:',
      CustomFields: 'Campi personalizzati:',
      StreakTarget: 'Obiettivo serie',
      TargetCriteria: "Criteri dell'obiettivo",
      StreakPeriod: 'Periodo della serie',
      Within: 'entro',
      TransactionsWithin: 'transazioni entro'
    },

    ActionMechanics: 'Meccaniche azione',

    InstantRewardMechanics: 'Meccaniche premio istantaneo',
    InstantRewardMechanicsLabel: "Mostrare la campagna nell'elenco campagne dell'utente?",
    IssuanceLimits: 'Limiti emissione',
    IssuanceLimitsLabel: 'Numero totale di eventi emissione-premio (a livello campagna)',
    AccountLifetimeMaxAvailableLabel: 'Numero totale di eventi emissione-premio (per utente)',
    RateLimitCampaignLabel: 'Limite frequenza (a livello campagna)',
    RateLimitUserLabel: 'Limite frequenza (per utente)',
    Outcomes: 'Risultati',
    IssuePrizeEvents: 'evento/i emissione-premio',
    LimitTo: 'Limita a',
    ForEvery: 'per ogni',

    PrizeSet: {
      Outcomes: 'risultati',
      PrizesOutcomes: 'Premi e risultati',
      WedgeOutcome: 'Risultato dello spicchio',
      QuizSelectableOne: 'Assegna premi per il completamento del quiz',
      QuizSelectableTwo: 'Assegna punti per risposta corretta',
      PointsPerAnswerLabel: 'Punti per risposta corretta:',
      Points: 'punti',
      Edit: 'Modifica',
      Remove: 'Rimuovi',
      ChangeReward: 'Cambia premio',
      ChangeBadge: 'Cambia badge',
      ChangePoints: 'Cambia punti',
      NoPrizeAdded: 'Nessun premio aggiunto',
      Prizes: 'Premi',
      AddRandomPrize: 'Aggiungi premio casuale',
      AddPrizeSet: 'Aggiungi set premio',
      AddRewards: 'Aggiungi premi',
      AwardPoints: 'Assegna punti',
      AwardBadges: 'Assegna badge',
      AddPrize: 'Aggiungi premio',
      IncludeNoPrizeAsOutcome: 'Includi nessun premio come risultato',

      GLACDetail: 'Dettaglio conto GL',
      GLACNo: 'N° conto GL',
      GLACName: 'Nome conto GL',
      GLACType: 'Tipo conto GL',
      CostCenterID: 'ID Centro di Costo',
      BranchCode: 'Codice Filiale',

      WinOdds: 'Probabilità di vittoria',
      Prize: 'Premio',
      Merchant: 'Commerciante',
      Balance: 'Saldo',
      PrizeIcon: 'Icona',

      GameTry: 'Tentativo di gioco',
      GameTryCampaignSelectWarningText:
        'Solo le campagne con emissione automatica dei tentativi di gioco disabilitata possono essere selezionate per emettere tentativi di gioco.',
      GameTryCampaignID: 'ID Campagna Tentativo di Gioco: {{campaignId}}',
      NumberofGameTries: 'Numero di Tentativi di Gioco',
      NoOutcome: 'Nessun risultato',
      Reward: 'Ricompensa',
      LoyaltyPoints: 'Punti fedeltà',
      Badge: 'Badge',
      PrizeSet: 'Set premio',
      Quantity: 'Quantità',
      NoPrize: 'Nessun premio'
    },

    PrizePerAnswer: {
      CountOfPointsValidationMessage: 'Specifica un Conteggio di Punti per risposta',
      LoyaltyProgramValidationMessage: 'Seleziona un programma fedeltà',
      Title: 'Punti Per Risposta Corretta',
      OkText: 'Salva',
      CancelText: 'Annulla',
      LoyaltyProgramLabel: 'Seleziona un programma fedeltà',
      LoyaltyProgramSelectPlaceholder: 'Seleziona programma fedeltà',
      CountOfPointsLabel: 'Assegna'
    },

    RewardSelectModal: {
      Title: 'Seleziona un premio',
      OkText: 'Aggiungi premio',
      CancelText: 'Annulla',
      SearchPlaceholder: 'Trova un premio per nome, id o commerciante',
      ID: 'ID',

      Tabs: {
        All: 'Tutti',
        Active: 'Attivi',
        Approved: 'Approvati',
        Private: 'Privati',
        System: 'Sistema'
      },

      Reward: 'Premio',
      Merchant: 'Commerciante',
      Balance: 'Saldo',
      SellingFrom: 'In vendita da',
      SellingTo: 'In vendita fino a'
    },

    IssuePointsModal: {
      ShowVariablePointsValidationMessage: 'Specifica un Conteggio di Punti',
      LoyaltyProgramValidationMessage: 'Specifica un programma fedeltà',
      ShowVariablePointsOutcomeValidatioMessage: 'Questo campo è obbligatorio',
      GLAccountTypeValidationMessage: 'Seleziona un Tipo di Conto GL',
      GLAccountNameValidationMessage: 'Seleziona un Nome di Conto GL',
      GLAccountIDValidationMessage: 'Seleziona un Conto GL',

      PleaseEnterAGreaterThanZero: 'Inserisci un valore maggiore di 0.',
      PleaseSpecifyTheNumberOfDays: 'Specifica il numero di giorni.',
      DaysMustBeAtLeastOne: 'I giorni devono essere almeno 1.',
      AwardedPointsExpireIn: 'I punti assegnati scadono in',
      NumberOfDaysToExpirePlaceholder: 'es. 7',
      Days: 'giorni',

      FixedPoints: 'Punti fissi',
      VariablePoints: 'Punti variabili',

      IssuePoints: 'Emetti Punti',
      Save: 'Salva',
      Cancel: 'Annulla',
      SelectLoyaltyProgramLabel: 'Seleziona un programma fedeltà',
      ShowVariablePointsAlertMessage:
        "Puoi assegnare punti fissi o variabili. Per i punti variabili, verrà considerata l'ultima transazione dell'utente.",
      NumberOfPointsToAward: 'Numero di punti da assegnare',
      NumberOfPointsToAwardPlaceholder: 'es.10',
      SelectGLAccount: 'Seleziona Conto GL',
      SelectGLAccountPlaceholder: 'Seleziona Conto GL',
      GLAccountType: 'Tipo Conto GL',
      GLAccountTypePlaceholder: 'Tipo Conto GL',
      GLAccountName: 'Nome Conto GL',
      GLAccountNamePlaceholder: 'Nome Conto GL',

      AwardedPointsExpire: 'I punti assegnati scadono',
      AfterXDays: 'dopo',
      OnCampaignEndDate: 'alla data di fine campagna',
      OnASpecificDate: 'in una data specifica',
      CampaignEndDateNotSet:
        'La campagna deve avere una data di fine per utilizzare questa opzione.',
      CampaignEndDateRequired:
        "Errore: È richiesta una data di fine campagna. Imposta una data di fine oppure disattiva l'opzione 'Alla data di fine campagna'.",
      PointsWillExpireOnEndDate: 'I punti scadranno il {{date}} alla data di fine campagna.',
      SelectExpiryDateTime: 'Seleziona data e ora di scadenza',
      PleaseSelectExpiryMode: "Seleziona un'opzione di scadenza.",
      PleaseSelectAnExpiryDate: 'Seleziona una data di scadenza.',
      PleaseSelectAnExpiryTime: 'Seleziona un orario di scadenza.',
      ExpiryDateMustBeInTheFuture: 'La data di scadenza deve essere nel futuro.',
      AwardedPointsExpireOnCampaignEndDate: 'I punti assegnati scadono alla data di fine campagna',
      AwardedPointsExpireOn: 'I punti assegnati scadono il',
      OnCampaignEndDateSuffix: 'alla data di fine campagna'
    },

    VariablePointsPane: {
      Transaction: 'Transazione',
      Award: 'Assegna',
      Every: 'Ogni',
      UpToAMaximumAmountOf: 'Fino a un importo massimo di'
    },

    BadgeSelectModal: {
      Title: 'Seleziona badge da visualizzare',
      OkText: 'Aggiungi badge',
      CancelText: 'Annulla'
    },

    BadgeListTable: {
      Name: 'Nome',
      StartDate: 'Data inizio',
      EndDate: 'Data fine',
      Actions: 'Azioni',
      ID: 'ID',
      SearchBadgesPlaceholder: 'Cerca badge',
      Edit: 'Modifica',
      Deactivate: 'Disattiva',
      Activate: 'Attiva',
      ErrorSortingBadgeMessage: "Errore durante l'ordinamento del badge.",
      ErrorUpdatingBadgeStateMessage: "Errore durante l'aggiornamento dello stato del badge",
      Status: 'Stato'
    },

    ReviewOutcomesDisplay: {
      IncludeNoOutcome: 'Includi nessun risultato',
      All: 'Tutti',
      Active: 'Attivi',
      Approved: 'Approvati',
      Inactive: 'Inattivi',
      Ended: 'Terminati',
      Private: 'Privati',
      Points: 'Punti',
      Custom: 'Personalizzato'
    },

    StampCampaignOutcomes: {
      GLAccountNo: 'N° Conto GL',
      GLAccountName: 'Nome Conto GL',
      CostCenterID: 'ID Centro di Costo',
      GLAccountDetail: 'Dettaglio Conto GL',

      Slot: 'Slot',
      OutcomeType: 'Tipo risultato',
      AddRewards: 'Aggiungi premi',
      AwardPoints: 'Assegna punti',
      AwardBadges: 'Assegna badge',
      AddPrizeToSet: 'Aggiungi premio al set',
      IncludeNoPrizeAsOutcome: 'Includi nessun premio come risultato',
      AddAnotherReward: 'Aggiungi un altro Premio',
      AddAnotherBadge: 'Aggiungi un altro Badge',
      RewardName: 'Nome premio',
      NumberOfPoints: 'Numero di punti',
      ID: 'ID',
      Reward: 'Premio',
      Action: 'Azione',
      Delete: 'Elimina',
      NoOutcome: 'Nessun risultato',
      ChangeByAddingReward: 'modifica aggiungendo premio',
      AddFixedPrizeSet: 'Aggiungi set premio fisso',
      AddRandomPrize: 'Aggiungi premio casuale',
      IssueReward: 'Emetti premio',
      IssuePoints: 'Emetti punti',
      IssueBadges: 'Emetti badge',
      AwardGameTry: 'Assegnare tentativi di gioco',
      SlotsWithOutcomeAdded: 'Slot con Risultato aggiunto',
      PleaseEnterPrizeTitle: 'Inserisci il titolo del premio',
      PrizeTitleRequired: 'Il titolo del premio è obbligatorio'
    },

    OutcomeSettings: {
      Title: 'Impostazioni Risultato',
      PrizeSet: 'Set Premio',
      Submit: 'Invia',
      MixedRewardsButtonText: 'Testo pulsante basato sul primo premio elencato',
      Headline: 'Titolo'
    },

    GameOutcomeScreens: {
      QuizScreens: 'Schermate quiz',
      SurveyScreens: 'Schermate sondaggio',
      LandingPage: 'Pagina di destinazione',
      LandingScreenHeading: 'Intestazione schermata di destinazione',
      LandingScreenSubheading: 'Sottotitolo schermata di destinazione',
      LandingScreenButtonText: 'Testo pulsante schermata di destinazione',
      LandingScreenText: 'Testo schermata di destinazione',
      OutcomeScreen: 'Schermata risultato',
      SuccessfulOutcomeImage: 'Immagine risultato positivo',
      SuccessfulOutcomeMessage: 'messaggio risultato positivo',
      SuccessfulOutcomeButton: 'pulsante risultato positivo',
      NoOutcomeMessage: 'messaggio nessun risultato',
      NoOutcomeButton: 'pulsante nessun risultato',
      NoOutcomeGraphic: 'grafica nessun risultato',
      OutcomeScreens: 'Schermate risultato',
      WinRewardGraphic: 'Grafica premio vinto',
      WinRewardMessage: 'Messaggio premio vinto',
      WinRewardButton: 'Pulsante premio vinto'
    },

    TeamMechanics: 'Meccaniche squadra',
    MemberPerTeam: 'Membri per squadra',
    DisplaySetup: 'Configurazione display',
    LandingPage: 'Pagina di destinazione',
    PreEnrolmentMessage: 'Messaggio pre-iscrizione',
    StampsEarnMessage: 'Messaggio guadagno timbri',
    JoinTeamPagePreview: {
      Title: 'Unisciti a una Squadra',
      ButtonText: 'Unisciti alla squadra',
      InputPlaceholder: 'Codice squadra'
    },
    JoinTeamPage: 'Pagina unione squadra',
    JoinTeamInfoMessage: 'Messaggio info unione squadra',
    InviteMemberMessage: 'Messaggio invito membro',
    InviteMemberMessageDescription: 'Descrizione messaggio invito membro',
    InviteMemberMessageBlurb: 'Testo messaggio invito membro',

    QuestMechanics: 'Meccaniche missione',
    UserTriesValidity: 'Validità tentativi utente',
    Task: 'Compito',
    QuestTask: {
      AddRule: 'Aggiungi regola',
      Required: '*obbligatorio'
    },
    TotalQuests: 'Numero totale di missioni che possono essere iniziate in una campagna',
    TotalQuestsPerUser: 'Numero totale di missioni che possono essere iniziate da ogni utente',
    DisplaySetItup: 'Configura display',

    CampaignRuleFormModal: {
      Title: 'Regola campagna',
      RuleName: 'Nome regola',
      Priority: 'Priorità',
      Outcome: 'Risultato',
      Edit: 'Modifica',
      Create: 'Crea',
      Update: 'Aggiorna',
      Add: 'Aggiungi',
      CancelText: 'Annulla',
      RequiredErrorMessage: 'Questo campo è obbligatorio.',
      OutcomeRewardRequiredErrorMessage: 'Seleziona un premio',
      OutcomePointsRequiredErrorMessage: 'Seleziona un programma fedeltà',
      GLAccountTypeRequiredErrorMessage: 'Seleziona un Tipo di Conto GL',
      GLAccountNameRequiredErrorMessage: 'Seleziona un Nome di Conto GL',
      OutcomeRequiredErrorMessage: 'Questo campo è obbligatorio',
      StampsWillBeIssued: 'Verranno emessi timbri',
      FixedPoints: 'Punti fissi',
      VariablePoints: 'Punti variabili',
      EarnType: 'Tipo di guadagno',
      Award: 'PREMIA',
      Points: 'punti',
      ForEvery: 'PER OGNI',
      Currency: 'Valuta',
      UpToAMaximumOf: 'FINO A UN MASSIMO DI',
      QuestOutcomeSegment: 'Il compito sarà contrassegnato come "completato"',
      InviteOutcomeSegment: 'Il compito sarà contrassegnato come "completato"',
      RaffleOutcomeSegment: "L'utente riceverà un biglietto della lotteria",
      FixedRaffleTickets: 'Biglietti della lotteria fissi',
      VariableRaffleTickets: 'Biglietti della lotteria variabili',
      RaffleTicketQuantitySuffix: 'Biglietto/i della lotteria',
      RaffleTicketQuantityPlaceholder: 'es. {{n}}',
      SelectOutcomeType: 'Seleziona tipo di risultato',
      Reward: 'Premio',
      ChangeReward: 'Cambia premio',
      SelectReward: 'Seleziona premio',
      SelectLoyaltyProgram: 'Seleziona programma fedeltà',
      NumberOfPoints: 'Numero di punti',
      SelectGLAccount: 'Seleziona Conto GL',
      GLAccountType: 'Tipo di Conto GL',
      GLAccountTypePlaceholder: 'tipo',
      GLAccountName: 'Nome Conto GL',
      GLAccountNamePlaceholder: 'nome',
      ValidityPeriod: 'Periodo di validità',

      ValidationMessages: {
        PleaseSelectATriggerEvent: 'Seleziona un evento trigger',
        PleaseSelectALoyaltyProgramValue: 'Seleziona un valore del programma fedeltà',
        PleaseSelectALoyaltyTierValue: 'Seleziona un livello del programma fedeltà',
        PleaseSelectACampaign: 'Seleziona una campagna',
        PleaseSelectAStampCampaign: 'Seleziona una campagna timbri',
        PleaseEnterTheNumberOfStamps: 'Inserisci il numero di timbri',
        NumberOfStampsMustBeAtLeastOne: 'Il numero di timbri deve essere almeno 1',
        StampPositionMustBeAtLeastOne: 'La posizione del timbro deve essere almeno 1',
        PleaseEnterTheStampPosition: 'Inserisci la posizione del timbro',
        PleaseSelectAnAutomationTrigger: 'Seleziona un trigger di automazione',
        IntervalCannotBeLessThanZero: "L'intervallo non può essere inferiore a zero",
        IntervalCannotBeGreaterThan365: "L'intervallo non può essere superiore a 365",
        PleaseEnterTheInterval: "Inserisci l'intervallo",
        PleaseSelectAMilestone: 'Seleziona una pietra miliare',
        PleaseSelectARule: 'Seleziona una regola',
        PleaseSelectAReward: 'Seleziona un premio',
        ThisFieldIsRequired: 'Questo campo è obbligatorio',
        TheFieldIsRequired: 'Il campo è obbligatorio',

        AttributeIsRequired: "L'attributo è obbligatorio",
        OperatorIsRequired: "L'operatore è obbligatorio",
        PleaseSelectAtLeastOneDay: 'Seleziona almeno un giorno',
        PleaseSelectATime: 'Seleziona un orario',
        FromTimeMustBeLessThanToTime: "L'orario di inizio deve essere precedente a quello di fine",
        PleaseSelectAFormTime: 'Seleziona un orario di inizio',
        PleaseSelectAnToTime: 'Seleziona un orario di fine',
        PleaseConfigureTheRuleTriggerDays: 'Configura i giorni di attivazione della regola',

        PleaseConfigureTheTrigger: 'Configura il trigger',
        PleaseFillInTheNameOfTheRule: 'Inserisci il nome della regola',
        PleaseSelectAnOwner: 'Seleziona un proprietario',
        PleaseSelectATriggerRule: 'Seleziona una regola trigger',
        PleaseSpecifyAStartTime: 'Specifica un orario di inizio',
        PleaseSpecifyAValidEndTime: 'Specifica un orario di fine valido',
        PleaseSelectAnOutcomeType: 'Seleziona un tipo di risultato',
        PleaseSelectAMediaTag: 'Seleziona un tag media',
        PleaseSelectAGLAccountType: 'Seleziona un tipo di conto GL',
        PleaseSelectAGLAccountName: 'Seleziona un nome di conto GL',
        GLAccountIDIsRequired: "L'ID del conto GL è obbligatorio",
        PleaseEnterAKey: 'Inserisci una chiave',
        AtLeastOneOutcomePropertyIsRequired: 'È richiesta almeno una proprietà del risultato',
        OutcomePropertiesAreRequired: 'Le proprietà del risultato sono obbligatorie',
        ValueMustBeGreaterThanZero: 'Il valore deve essere maggiore di zero.',
        ValueCannotBeZero: 'Il valore non può essere zero.',
        PleaseEnterANumber: 'Inserisci un numero',
        PleaseEnterAWholeNumber: 'Inserisci un numero intero',
        NumberMustBeAPositiveNumber: 'Il numero deve essere positivo',
        EnterAWholeNumber: 'Inserisci un numero intero',

        OutcomeRequiredErrorMessage: 'Questo campo è obbligatorio',
        OutcomePointsRequiredErrorMessage: 'Seleziona un programma fedeltà'
      }
    },
    SelectTriggerSection: {
      SelectATrigger: 'Seleziona un trigger',
      Custom: 'Personalizzato',
      Transaction: 'Transazione',
      Loyalty: 'Fedeltà',
      Campaign: 'Campagna',
      Customer: 'Cliente',
      Reward: 'Premio',
      Location: 'Posizione',
      SelectTrigger: 'Seleziona Trigger',
      SelectATriggerPlaceholder: 'Seleziona un trigger',
      Others: 'Personalizzato',
      LoyaltyTrigger: {
        HelpText:
          "Il numero di punti in scadenza verrà controllato all'inizio di ogni ciclo di revisione.",
        AchievedNextTier: 'Livello Successivo Raggiunto',
        TenPercentCloseToNextTier: '10% Vicino al Livello Successivo',
        PointsIssued: 'Punti Emessi',
        AgeingPoints: 'Punti in scadenza (punti che scadranno nel ciclo corrente)',
        SelectLoyaltyProgram: 'Seleziona Programma Fedeltà',
        SelectNextTier: 'Seleziona Livello Successivo',
        SelectNextTierPlaceholder: 'Seleziona un livello fedeltà'
      },
      RewardTrigger: {
        RedeemReward: 'Riscatta Premio',
        IssueReward: 'Emetti Premio',
        IssueRewardFromCampaign: 'Emetti Premio dalla Campagna',
        IssueRewardFromMerchant: 'Emetti Premio dal Commerciante',
        VoucherForParticularRewardExpiringIn: 'Voucher per un Premio specifico in scadenza tra',
        AnyVoucherExpiringIn: 'Qualsiasi voucher in scadenza tra {{days}}'
      },

      MilestoneTrigger: {
        StampRedeemed: 'Timbro Riscattato',
        StampsIssued: 'Timbri Emessi',
        StampsInactive: 'Timbri Inattivi',
        GamePlayed: 'Gioco Giocato',
        GameTryIssued: 'Tentativo di Gioco Emesso',
        CampaignEnrolled: 'Iscritto alla Campagna',
        CampaignCompleted: 'Campagna Completata',
        CampaignNotCompleted: 'Campagna Non Completata',
        ProgressLevelAchieved: 'Livello di Progresso Raggiunto',
        ProgressRuleTriggered: 'Regola di Progresso Attivata',
        QuestTaskCompleted: 'Compito della Missione Completato',

        SelectAStampCampaign: 'Seleziona una Campagna Timbri',
        Change: 'Cambia',
        Select: 'Seleziona',
        Stamp: 'Timbro',
        Campaign: 'Campagna',
        ID: 'ID',
        FooterMsg:
          'Qualsiasi premio {{isCampaignRewardsSelected}} in questa campagna sarà un trigger',
        SelectStampsSlot: 'Seleziona Slot Timbri',
        StampCardPosition: 'Posizione Carta Timbri'
      },

      CustomerTrigger: {
        SignUp: 'Registrazione',
        SignIn: 'Accesso',
        ProfileUpdated: 'Profilo Aggiornato'
      },

      TransactionTrigger: {
        SelectATriggerPlaceholder: 'Scegli Uno...',
        FromDate: 'Data Inizio',
        ToDate: 'Data Fine',
        SelectOperator: 'Seleziona Operatore',
        PropertyDataType: 'Tipo di dati proprietà',
        Key: 'Chiave',
        Operator: 'Operatore',
        Sunday: 'Domenica',
        Monday: 'Lunedì',
        Tuesday: 'Martedì',
        Wednesday: 'Mercoledì',
        Thursday: 'Giovedì',
        Friday: 'Venerdì',
        Saturday: 'Sabato',
        Value: 'Valore',
        PleaseSeparateMultipleValuesUsingComma: 'Separa più valori usando la virgola',
        SelectTrigger: 'Seleziona Trigger',
        And: 'E',
        AddCondition: 'Aggiungi Condizione'
      },

      LocationTrigger: {
        EnterLocationDetails: 'Inserisci Dettagli Posizione',
        Latitude: 'Latitudine',
        Longitude: 'Longitudine',
        LatitudeDegrees: 'Gradi ( -90.0 a 90.0 )',
        LongitudeDegrees: 'Gradi ( -180.0 a 180.0 )',
        PermissibleRadius: 'Raggio Consentito (In Metri)',
        Radius: 'Raggio Consentito',
        Preview: 'ANTEPRIMA'
      },

      CampaignSelectField: {
        Interval: 'Intervallo',
        Days: '(Giorni)',
        SelectAStampCampaign: 'Seleziona una Campagna Timbri',
        Change: 'Cambia',
        Select: 'Seleziona',
        Stamp: 'Timbro',
        SelectACampaign: 'Seleziona una campagna',
        Edit: 'Modifica',
        Add: 'Aggiungi',
        Campaign: 'Campagna',
        SelectAMilestone: 'Seleziona un Traguardo',
        SelectARule: 'Seleziona una Regola',
        SelectATask: 'Seleziona un Compito'
      },

      GameSelectField: {
        SelectAGameCampaign: 'Seleziona una Campagna Gioco',
        Game: 'Gioco',
        Campaign: 'Campagna',
        Change: 'Cambia',
        Select: 'Seleziona'
      },

      CampaignRewardSelectField: {
        SelectACampaign: 'Seleziona una Campagna',
        Change: 'Cambia',
        Select: 'Seleziona',
        Campaign: 'Campagna',
        SelectAReward: 'Seleziona un Premio (Opzionale)',
        Reward: 'Premio'
      },

      MerchantRewardSelectField: {
        SelectAMerchant: 'Seleziona un Commerciante',
        Change: 'Cambia',
        Select: 'Seleziona',
        Merchant: 'Commerciante',
        AddMerchant: 'Aggiungi Commerciante',
        Cancel: 'Annulla',
        SearchMerchant: 'Cerca commerciante per nome o ID',
        Active: 'Attivo',
        Inactive: 'Inattivo'
      },

      RewardSelectField: {
        SelectAReward: 'Seleziona un Premio (Opzionale)',
        Change: 'Cambia',
        Reward: 'Premio',
        Select: 'Seleziona',
        WarningText:
          'Il Tipo di Risultato è limitato a [Push Event] quando viene selezionato un premio di Sistema'
      },

      RewardExpirySetupField: {
        SelectAReward: 'Seleziona un Premio',
        Change: 'Cambia',
        Select: 'Seleziona',
        Reward: 'Premio',
        Periods: 'Periodi (Giorni)'
      }
    },

    RuleTriggerLimitSegment: {
      Title: 'Limiti trigger:',
      TotalTriggerEvents: 'Numero totale di eventi trigger (a livello campagna)',
      TotalTriggerEventsPerUser: 'Numero totale di eventi trigger (per utente)',
      TriggerRateLimitPerUser: 'Limite frequenza trigger (per utente)',
      LeaveTheLimitFieldsBlankForUnlimitedTriggerEvents:
        '- Lascia i campi limite vuoti per eventi trigger illimitati -',
      Days: 'Giorni',
      Weeks: 'Settimane',
      Months: 'Mesi',
      Years: 'Anni',
      TriggerEventForEvery: 'evento/i trigger per ogni',
      AccountIntervalLimitPlaceholder: 'es., 2',
      AccountIntervalUnitsPlaceholder: 'es., 1',
      TriggerLimitPlaceholder: '∞',
      TriggerAccountLimitPlaceholder: '∞',
      LimitTo: 'Limita a'
    },

    RuleAudience: {
      SelectFilters: 'Seleziona filtri',
      Age: 'Età',
      Gender: 'Genere',
      Location: 'Posizione',
      Language: 'Lingua',
      Device: 'Dispositivo',
      Browser: 'Browser',
      Customs: 'Personalizzati',
      Ethnicity: 'Etnia',
      Loyalty: 'Fedeltà',
      EmailTags: 'Tag email',
      BirthMonth: 'Mese di nascita',
      NoFiltersSelected: 'Nessun filtro selezionato',
      SelectedFilters: 'Filtri selezionati'
    },

    LoyaltyTier: {
      Includes: 'include',
      UsersWhoAchieved: 'Utenti che hanno raggiunto',
      SelectProgramAndTier: 'Seleziona programma e livello'
    },

    LevelsAndPrizes: 'Livelli e Premi',

    LevelWrapper: {
      ValidatePointHelpMessage:
        'I punti del livello {{level}} devono essere maggiori dei punti del livello {{previousLevel}}!',
      LevelTitle: 'Visualizzazione livello {{level}}',
      TotalCampaignPointsRequired: 'Punti campagna totali richiesti per completare questo livello:'
    },

    ClaimPrizePopUp: 'Pop up `Riscatta premio`',

    LandingPagePreview: {
      CampaignName: 'Nome campagna',
      Description: 'Descrizione',
      TermsAndConditions: 'Termini e condizioni',
      PRIZE: 'PREMIO',
      PrizeSet: 'Set premio',
      StartPlaying: 'Inizia a giocare'
    },

    EnrolmentPage: 'Pagina iscrizione',

    RuleGroupLandingPagePreview: {
      CampaignName: 'Nome campagna',
      EnrollText: 'ISCRIVITI',
      EnrollNow: 'Iscriviti ora',
      TermsAndConditions: 'Termini e condizioni generali'
    },

    RaffleReview: {
      DisplaySettings: 'Impostazioni display',
      LandingPage: 'Pagina di destinazione',
      RaffleTicket: 'Biglietto lotteria',
      GrandPrize: 'Premio principale',
      GrandPrizes: 'Premi principali'
    },

    DrawSection: {
      RaffleDraw: 'Estrazione lotteria',
      DownloadCSV: 'Scarica CSV',
      GenerateRaffleWinners: 'Genera vincitori lotteria',
      SomethingWentWrong: 'Qualcosa è andato storto',
      RaffleCampaignPending: `La campagna lotteria è terminata. Clicca su 'Genera vincitori lotteria' per attivare \
            l'estrazione e assegnare automaticamente i premi ai vincitori. Potrai vedere la lista dei \
            vincitori una volta completata l'estrazione.`,
      RaffleCampaignSuccess:
        "L'estrazione della lotteria è completata e i vincitori hanno ricevuto i premi principali."
    },

    GenerateWinnerModal: {
      GeneratingRaffleWinners: 'Generazione vincitori lotteria...'
    },

    RaffleWinnersTable: {
      Position: 'Posizione',
      FirstName: 'Nome',
      LastName: 'Cognome',
      CustomerID: 'ID Cliente',
      TicketCode: 'Codice biglietto',
      GrandPrize: 'Premio principale',
      PrizeSet: 'Set premio',
      ErrorFetchingWinnersList: 'Errore nel recupero della lista vincitori',
      Reversed: 'Annullato'
    },

    ConfigureRaffleCodesReview: {
      ConfigureRaffleCodes: 'Configura codici lotteria',
      CodeGenerationMethod: 'Metodo generazione codice',
      TicketCodePrefix: 'Prefisso codice biglietto',
      LengthOfCode: 'Lunghezza codice',
      TotalPermutations: 'Permutazioni totali',
      VoucherCodeFormat: 'Formato codice voucher',
      VoucherCodeLength: 'Lunghezza codice voucher',
      NumberOfTickets: 'Numero di biglietti',
      CodeFormat: 'Formato codice'
    },

    RewardAddedTable: {
      Order: 'Ordine',
      Probability: 'Probabilità',
      Name: 'Nome',
      Value: 'Valore',
      Operators: 'Operatori',
      RuleName: 'Nome regola',
      NoOutcome: 'Nessun risultato',
      AwardPoints: 'Assegna punti',
      Merchant: 'Commerciante',
      ID: 'ID',
      SellingFrom: 'In vendita da',
      SellingTo: 'In vendita fino a',
      RewardBalance: 'Saldo premio',
      PointsAwarded: 'Punti assegnati',
      ReferrerLimits: 'Limiti referente',
      RefferalsNeeded: 'Referenze necessarie',
      ReffererRewardLimit: 'Limite premio referente',
      RefereeLimits: 'Limiti referee',
      GLACNo: 'N° conto GL',
      GLACName: 'Nome conto GL',
      CostCenterID: 'ID Centro di Costo',
      BranchCode: 'Codice Filiale',
      GLAccountDetail: 'Dettaglio conto GL',
      ExpiresInDays: 'Scade tra {{count}} giorni',
      ReferrerGameTryIssued: 'Tentativo di gioco Referente',
      RefereeGameTryIssued: 'Tentativo di gioco Arbitro'
    },

    QuizQuestionsReview: {
      Questions: 'Domande',
      Type: 'Tipo',
      TextQuestion: 'Domanda testuale',
      ImageQuestion: 'Domanda con immagine',
      WrittenResponse: 'Risposta scritta',
      MultipleAnswers: 'Risposte multiple',
      SingleAnswer: 'Risposta singola',
      Question: 'Domanda',
      Required: 'Obbligatorio',
      Yes: 'Sì',
      No: 'No'
    },

    QuestRuleTable: {
      ID: 'ID',
      Name: 'Nome',
      Status: 'Stato',
      Action: 'Azione',
      Edit: 'Modifica',
      Remove: 'Rimuovi'
    },

    BulkActionModal: {
      FileUploadedIsSubmittedForApproval: 'Il file caricato è stato inviato per approvazione',
      FileUploaded: 'File caricato',
      ErrorUploadingFile: 'Errore durante il caricamento del file.',
      Cancel: 'Annulla',
      Upload: 'Carica',
      BulkUpload: 'Caricamento massivo',
      ChooseOne: 'Scegli uno...',
      Campaign: 'Campagna',
      PleaseSelectACampaign: 'Seleziona una campagna',
      LoyaltyProgram: 'Programma fedeltà',
      PleaseSelectALoyaltyProgram: 'Seleziona un programma fedeltà',
      ClickOrDragFileToThisAreaToUpload: 'Clicca o trascina il file in questa area per caricare',
      DownloadSample: 'Scarica esempio',
      ActionType: 'Tipo di azione',
      AcceptedFormatXlsxOrCsvFilesOnly: 'Formato accettato: solo file .xlsx o .csv',
      AcceptedFormatTxtXlsxOrCsvFilesOnly: 'Formato accettato: solo file .txt, .xlsx o .csv'
    }
  },

  [ReferralRewardModeKey]: {
    Label: 'Tipo di ricompensa referral',
    Fixed: 'Ricompensa referral fissa',
    TierBased: 'Ricompensa referral a livelli'
  },

  [ReferralTierLadderKey]: {
    AddTier: 'Aggiungi livello',
    RemoveTier: 'Rimuovi livello',
    EditTier: 'Modifica livello',
    Threshold: 'Soglia conteggio referral',
    TierOutcome: 'Risultato del livello',
    TierDisplaySettings: 'Impostazioni di visualizzazione del livello',
    TierTitle: 'Titolo del livello',
    TierSubtitle: 'Sottotitolo del livello',
    TierIcon: 'Icona del livello',
    UploadCustomIcon: 'Carica icona personalizzata',
    RefereeOutcome: 'Risultato del referenziato',
    EmptyState: 'Nessun livello configurato. Aggiungi livello per iniziare.',
    DuplicateThreshold: 'Un altro livello ha la stessa soglia',
    GameTry: 'Tentativo di gioco',
    CurrentTier: 'Livello attuale',
    NextTier: 'Livello successivo',
    Voucher: 'Voucher',
    Points: 'Punti',
    Badge: 'Distintivo',
    OutcomeType: 'Tipo di risultato',
    Save: 'Salva',
    Cancel: 'Annulla',
    MissingThreshold: 'La soglia è obbligatoria',
    MinThresholdError: 'La soglia deve essere almeno 1',
    Rule: 'Regola',
    Actions: 'Azioni',
    RuleConfigured: 'Regola configurata',
    Title: 'Scala dei livelli',
    ReferralsRequired: 'referral richiesti',
    MechanicsTitle: 'Meccanica dei livelli di referral',
    TierName: 'Livello',
    ThresholdInline: 'REFERRAL CUMULATIVI RICHIESTI',
    ThresholdHelper:
      "Inserisci il numero totale cumulativo di referral riusciti necessari per sbloccare questo livello. I referral dei livelli precedenti sono inclusi. Ad esempio, Livello 1 = 1 e Livello 2 = 4 significa che l'utente ha bisogno di 3 referral aggiuntivi dopo aver completato il Livello 1.",
    AddRule: 'Aggiungi regola',
    RuleName: 'Nome',
    Prize: 'Premio',
    AddPrize: 'Aggiungi premio',
    AddRewards: 'Aggiungi ricompense',
    AddPoints: 'Aggiungi punti',
    AddBadge: 'Aggiungi distintivo',
    AddGameTry: 'Aggiungi tentativo di gioco',
    NoData: 'Nessun dato',
    NoPrizes: 'Nessun premio aggiunto',
    TierHeadline: 'Intestazione del livello',
    TierSubHeadline: 'Sotto-intestazione del livello',
    RewardBalance: 'Saldo ricompensa',
    PointsAwarded: 'Punti assegnati',
    ReferrerLimits: 'Limiti del referrer',
    ReferralsNeeded: 'Referral necessari',
    RefereeRewardLimit: 'Limite ricompensa del referenziato'
  },

  [ReferralBulkActionsKey]: {
    UploadRefereeUsers: 'Carica utenti referenziati',
    UploadReferralCount: 'Carica conteggio referral',
    SelectActiveReferralCampaign: 'Seleziona una campagna referral attiva',
    DownloadSampleTemplate: 'Scarica modello di esempio',
    RuleBypassWarning:
      'Per le campagne con condizioni basate su regole, le regole non verranno valutate durante il caricamento del conteggio referral. Le ricompense verranno emesse solo in base al conteggio referral caricato.'
  },

  [ReferralReportsKey]: {
    InviteEarnSummary: 'Riepilogo Invita & Guadagna',
    InviteEarnBreakdown: 'Dettaglio Invita & Guadagna',
    AggregatedReferralCountSummary: 'Riepilogo conteggio referral aggregato',
    AggregatedReferralCountBreakdown: 'Dettaglio conteggio referral aggregato'
  },

  [ReferralAnalyticsKey]: {
    ReferralPerformance: 'Performance referral',
    TotalReferrers: 'Referrer totali',
    TotalReferees: 'Referenziati totali',
    TotalSuccessfulReferrals: 'Referral riusciti totali',
    ReferralCompletionRate: 'Tasso di completamento referral',
    CustomerEngagementRate: 'Tasso di coinvolgimento clienti',
    ReferrersPerTier: 'Referrer per livello',
    OutcomesIssued: 'Risultati emessi',
    TierColumn: 'Livello',
    ReferrersColumn: 'Referrer',
    RefereesColumn: 'Referenziati',
    KeyMetrics: 'Metriche chiave',
    TotalSuccessfulReferralsHelp:
      'Numero totale di referral che hanno completato tutte le azioni qualificanti.',
    ReferralCompletionRateHelp:
      'Percentuale di referral avviati che sono stati completati con successo.',
    CustomerEngagementRateHelp:
      'Percentuale di pubblico raggiunto che ha interagito con la campagna referral.'
  }
};
